
/// <reference types="jquery" />


declare var Swal: any;
declare function matPreloader(type: 'on' | 'off'): void;
declare function fncSweetAlert(type: string, text: string, url?: string | null): Promise<any>;
declare function fncSweetAlertToast(type: 'success' | 'error' | 'warning' | 'info' | 'question', text: string): void;
declare function fncFormatInputs(): void;
declare function start_loader(): void;
declare function end_loader(): void;

interface ApiResponse {
    status: number;
    message: string;
    token?: string;
    data?: any;
}

/*=============================================
Función para recordar credenciales de ingreso
=============================================*/

function rememberMe(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
        const email = $('[name="emailLogin"]').val();
        localStorage.setItem("emailRemember", String(email));
        localStorage.setItem("checkRemember", 'true');
    } else {
        localStorage.removeItem("emailRemember");
        localStorage.removeItem("checkRemember");
    }
}

/*=============================================
Capturar el email para login desde el LocalStorage
=============================================*/

$(document).ready(function () {
    const emailRemember = localStorage.getItem("emailRemember");
    if (emailRemember) {
        $('[name="emailLogin"]').val(emailRemember);
    }

    if (localStorage.getItem("checkRemember")) {
        $('#remember').attr("checked", "true");
    }
    $('#confirm-password').on('input', function () {
        var password_nuevo = $('#password').val();
        if ($(this).val() == password_nuevo) {
            $('#resultado_password').text('Las contraseñas coinciden!');
            $('#resultado_password').parents('.alert').addClass('alert-success').removeClass('alert-danger');
            $('#password').parent().addClass('has-success').removeClass('has-error');
            $('#confirm-password').parent().addClass('has-success').removeClass('has-error');
        } else {
            $('#resultado_password').text('Las contraseñas no coinciden.');
            $('#resultado_password').parents('.alert').addClass('alert-danger').removeClass('alert-success');
            $('#password').parent().addClass('has-error').removeClass('has-success');
            $('#confirm-password').parent().addClass('has-error').removeClass('has-success');
        }
    });

    ($('.expire_plan') as any).datepicker({
        dateFormat: 'dd/mm/yy', // Formato de fecha
        onSelect: function (dateText: string, inst: any) {
            // Aquí puedes hacer lo que necesites con la fecha seleccionada
        },
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'], // Nombres de los días de la semana (abreviados)
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'], // Nombres de los meses
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'], // Nombres de los meses (abreviados)
        prevText: 'Anterior', // Texto del botón "Anterior"
        nextText: 'Siguiente', // Texto del botón "Siguiente"
        currentText: 'Hoy', // Texto del botón "Hoy"
        closeText: 'Cerrar', // Texto del botón "Cerrar"
        firstDay: 1, // Primer día de la semana (0: Domingo, 1: Lunes, etc.)
        showMonthAfterYear: false, // Mostrar el mes después del año en el encabezado del selector de fecha
        yearSuffix: '', // Sufijo para el año en el encabezado del selector de fecha
    });

    // Cuando haces clic en el input, mostrar el datepicker
    $('.expire_plan').on('dblclick', function () {
        ($(this) as any).datepicker("show");
    });

    ($('.datepicker_portal') as any).datepicker({
        dateFormat: 'dd M yy', // Formato para Radius (Ej: 15 Dec 2025) - ajustado para que coincida aprox
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], // English short names for Radius compatibility if needed? Or Spanish? 
        // Radius usually needs English months: Jan, Feb...
        // Let's try to match the placeholder "15 Dec 2025"
        // jQuery UI 'M' is short month name.
        prevText: 'Anterior',
        nextText: 'Siguiente',
        currentText: 'Hoy',
        closeText: 'Cerrar',
        firstDay: 1,
        showMonthAfterYear: false,
        yearSuffix: '',
    });

    $('.datepicker_portal').on('dblclick', function () {
        ($(this) as any).datepicker("show");
    });

    /**
     * Javascript de login
     */
    $('#formLogin').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        let formLogin = $('#formLogin').get(0) as HTMLFormElement;
        var data = new FormData(formLogin);
        data.append("access", "true");

        $.ajax({
            url: "/auth/login",
            method: "POST",
            data: data,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: ApiResponse) {
                console.log("response ", response);
                fncFormatInputs();
                matPreloader("off");

                if (response.status == 200 && response.token) {
                    window.location.href = "/admin/home";
                } else if (response.status == 401) {
                    Swal.fire({
                        icon: "warning",
                        text: response.message,
                        footer: '<a href="verifyEmail?newVerifyEmail=true" class="link-primary fw-bold"> Solicitar nuevo correo de verificación</a>'
                    });
                } else if (response.status == 403) {
                    fncSweetAlert("warning", response.message, "");
                } else if (response.status == 404) {
                    fncSweetAlert("error", response.message, "");
                } else if (response.status == 406) {
                    fncSweetAlert("error", response.message, "");
                }
            }
        });
    });

    // Inicializar tabla de planes de suscripción para empresas
    if ($('#tablePlans').length > 0) {
        const tablePlans = initializeDataTable("#tablePlans", "/admin/tables/plans", {
            "columns": [
                { "data": 0 },
                { "data": 1 },
                { "data": 2 },
                { "data": 3 },
                { "data": 4 },
                { "data": 5 },
                { "data": 6 },
                { "data": 7 }
            ]
        });
    }


    $("#btnAgregarPlan").on('click', function (e: JQuery.ClickEvent) {
        e.preventDefault();
        ($('#formPlans')[0] as HTMLFormElement).reset();
        $('#formPlans').removeClass("was-validated");
    });

    // Registro de nuevo Plan
    const formAddPlan = document.getElementById('form_add_plan');
    if (formAddPlan) {
        formAddPlan.addEventListener('submit', function (e) {
            e.preventDefault();
            matPreloader("on");
            const formData = new FormData(this as HTMLFormElement);

            fetch('/admin/plans/create', { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {
                    matPreloader("off");
                    if (data.status === 200) {
                        fncSweetAlertToast('success', data.message);
                        ($('#modal_add_plan') as any).modal('hide');
                        (formAddPlan as HTMLFormElement).reset();
                        ($('#tablePlans') as any).DataTable().ajax.reload();
                    } else {
                        fncSweetAlert("error", data.message, "");
                    }
                });
        });
    }

    // Edición de Plan - Abrir Modal
    $(document).on('click', '.itemEditPlan', function () {
        const id = $(this).attr('data-id');
        const nombre = $(this).attr('data-nombre');
        const desc = $(this).attr('data-desc');
        const precio = $(this).attr('data-precio');
        const prop = $(this).attr('data-prop');
        const med = $(this).attr('data-med');
        const freq = $(this).attr('data-freq');
        const status = $(this).attr('data-status');

        $('#edit_id_plan').val(id || '');
        $('#edit_name_plan').val(nombre || '');
        $('#edit_description_plan').val(desc || '');
        $('#edit_price_plan').val(precio || '0.00');
        $('#edit_limite_propiedades_plan').val(prop || '1');
        $('#edit_limite_medidores_plan').val(med || '10');
        $('#edit_duration_plan').val(freq || 'mensual');
        $('#edit_status_plan').val(status || '1');

        ($('#modal_edit_plan') as any).modal('show');
    });

    // Edición de Plan - Guardar
    const formEditPlan = document.getElementById('form_edit_plan');
    if (formEditPlan) {
        formEditPlan.addEventListener('submit', function (e) {
            e.preventDefault();
            matPreloader("on");
            const formData = new FormData(this as HTMLFormElement);

            fetch('/admin/plans/edit', { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {
                    matPreloader("off");
                    if (data.status === 200) {
                        fncSweetAlertToast('success', data.message);
                        ($('#modal_edit_plan') as any).modal('hide');
                        ($('#tablePlans') as any).DataTable().ajax.reload();
                    } else {
                        fncSweetAlert("error", data.message, "");
                    }
                });
        });
    }

    // Eliminar Plan
    $(document).on('click', '.itemDeletePlan', function () {
        const id = $(this).attr('data-id');
        fncSweetAlert("confirm", "¿Estás seguro de eliminar este plan?", "").then(resp => {
            if (resp) {
                const formData = new FormData();
                formData.append('i', String(id));
                formData.append('table', 'plans');
                formData.append('suffix', 'plan');

                fetch('/admin/tables/delete', { method: 'POST', body: formData })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 200) {
                            ($('#tablePlans') as any).DataTable().ajax.reload();
                            fncSweetAlertToast('success', 'Plan eliminado');
                        }
                    });
            }
        });
    });

    $(document).on("click", ".table tbody .itemDelete", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let i = $(this).attr("i") ?? '';
        let DataTable = $(this).closest("table.table");
        deteleItem(table, suffix, i, DataTable);
    });

    $(document).on("click", "#tableClients tbody .dropdown-menu .itemDelete", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const table = $(this).attr("table") ?? '';
        const suffix = $(this).attr("suffix") ?? '';
        const i = $(this).attr("i") ?? '';
        let DataTable = $(this).closest("table.table");
        deteleItem(table, suffix, i, DataTable);
    });

    $(".table tbody").on("click", ".itemEdit", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        start_loader();
        ($("#modalEdit") as any).modal("show");
        ($('#formEditPlans')[0] as HTMLFormElement).reset();
        $('#formEditPlans').removeClass("was-validated");

        let i = $(this).attr("i") ?? '';
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let url = "/admin/tables/get";
        editItem(url, table, suffix, i, function (response: ApiResponse) {
            end_loader();
            if (response.status == 200) {
                $("#i").val(response.data.id_plan);
                $("#type_plan").val(response.data.type_plan);
                $("#name_plan").val(response.data.name_plan);
                $("#price_plan").val(response.data.price_plan);
                $("#broadband_plan").val(response.data.broadband_plan);
                $("#duration_plan").val(response.data.duration_plan);
                $("#oferta_plan").val(response.data.oferta_plan);
                $("#expire_oferta_plan").val(response.data.expire_oferta_plan);
                $("#description_plan").val(response.data.description_plan);
                $("#dispositivos_plan").val(response.data.dispositivos_plan);
                $("#includes_plan").val(response.data.includes_plan);
                if (response.data.recomendar_plan === 1) {
                    $("#recomendar_plan").prop('checked', true);
                    $("#recomendar_plan").val(1); // Actualizar el valor del checkbox
                }
            } else {
                fncSweetAlertToast('error', 'Datos no obtenidos actualizar la pagina o iniciar sesión nuevamente');
            }
        });
    });

    /**
     * javascrip clients
     */


    $('#formClients').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        let formClients = $('#formClients').get(0) as HTMLFormElement;
        var data = new FormData(formClients);
        data.append("newClient", "true");
        const url = "/admin/client/create";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableClients").DataTable().ajax.reload();
                ($("#AgregarClient") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    const tableClients = initializeDataTable("#tableClients", "/admin/tables/clients");
    (window as any).tablePropiedades = initializeDataTable("#tablePropiedades", "/admin/tables/propiedades");

    $(document).on("click", "#tableClients tbody .btnStatus", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const i = $(this).attr("i");
        const status = $(this).attr("status");
        const text = (status == "1") ? "activar" : "desactivar";

        Swal.fire({
            text: `¿Estás seguro de ${text} este usuario?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#7066e0',
            cancelButtonColor: '#dd3333e3',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result.isConfirmed) {
                matPreloader("on");
                const data = new FormData();
                data.append("i", String(i));
                data.append("status", String(status));
                data.append("token", localStorage.getItem("token_user") ?? "");

                $.ajax({
                    url: "/admin/tables/status",
                    method: "POST",
                    data: data,
                    contentType: false,
                    cache: false,
                    processData: false,
                    dataType: "json",
                    success: function (response: ApiResponse) {
                        matPreloader("off");
                        if (response.status == 200) {
                            fncSweetAlertToast("success", "Estado actualizado correctamente");
                            ($("#tableClients") as any).DataTable().ajax.reload();
                        } else {
                            fncSweetAlert("error", "Ocurrió un error al actualizar el estado", "");
                        }
                    }
                });
            }
        });
    });

    $(document).on("click", "#tableClients tbody .dropdown-menu .itemEdit", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();

        ($("#modalEdit") as any).modal("show");
        ($('#formEditClients')[0] as HTMLFormElement).reset();
        $('#formEditClients').removeClass("was-validated");

        let i = $(this).attr("i") ?? '';
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let url = "/admin/tables/get";

        editItem(url, table, suffix, i, function (response: ApiResponse) {
            console.log(response)
            end_loader();
            if (response.status == 200) {
                $("#i").val(response.data.id_user);
                $("#dni_user").val(response.data.dni_user);
                $("#first_name_user").val(response.data.first_name_user);
                $("#last_name_user").val(response.data.last_name_user);
                $("#email_user").val(response.data.email_user);
                $("#phone_user").val(response.data.phone_user);
                $("#address_user").val(response.data.address_user);
                $("#rol_user").val(response.data.rol_user);
            } else {
                fncSweetAlertToast('error', 'Datos no obtenidos actualizar la pagina o iniciar sesión nuevamente');
            }
        });
    });

    $('#formEditClients').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        let formEditClients = $('#formEditClients').get(0) as HTMLFormElement;
        var data = new FormData(formEditClients);
        data.append("editClient", "true");

        $.ajax({
            url: "/admin/client/edit",
            method: "POST",
            data: data,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: ApiResponse) {
                console.log("response ", response);
                fncFormatInputs();
                matPreloader("off");

                if (response.status == 200) {
                    $("#tableClients").DataTable().ajax.reload();
                    ($("#modalEdit") as any).modal("hide");
                    fncSweetAlertToast('success', response.message);
                } else {
                    fncSweetAlert("error", response.message, "");
                }
            }
        });
    });

    /**
     * javascript para administrador
     */

    const tableAdmins = initializeDataTable("#tableAdmins", "/admin/tables/admins");
    $("#btnAgregarAdmin").on('click', function (e: JQuery.ClickEvent) {
        e.preventDefault();
        ($('#formAdmins')[0] as HTMLFormElement).reset();
        $('#formAdmins').removeClass("was-validated");
    });

    $('#formAdmins').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        let formAdmins = $('#formAdmins').get(0) as HTMLFormElement;
        var data = new FormData(formAdmins);
        data.append("newAdmin", "true");
        const url = "/admin/admin/create";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $(".table").DataTable().ajax.reload();
                ($("#AgregarAdmin") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    $(document).on("click", "#tableAdmins tbody .itemEdit", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        start_loader();
        var data = new FormData();
        data.append("listar", "true");
        data.append("table", "plans");
        data.append("suffix", "plan");

        ($("#modalEdit") as any).modal("show");
        ($('#formEditAdmins')[0] as HTMLFormElement).reset();
        $('#formEditAdmins').removeClass("was-validated");

        let i = $(this).attr("i") ?? '';
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let url = "/admin/tables/get";

        editItem(url, table, suffix, i, function (response: ApiResponse) {
            end_loader();
            if (response.status == 200) {
                $("#i").val(response.data.id_user);
                $("#dni_user").val(response.data.dni_user);
                $("#name_user").val(response.data.name_user);
                $("#first_name_user").val(response.data.first_name_user);
                $("#last_name_user").val(response.data.last_name_user);
                $("#email_user").val(response.data.email_user);
                $("#phone_user").val(response.data.phone_user);
                $("#address_user").val(response.data.address_user);
                $("#username_user").val(response.data.username_user);
                $("#rol_user").val(response.data.rol_user);
            } else {
                fncSweetAlertToast('error', 'Datos no obtenidos actualizar la pagina o iniciar sesión nuevamente');
            }
        });
    });

    $('#formEditAdmins').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        const token = localStorage.getItem("token_user") ?? "";
        let formEditAdmins = $('#formEditAdmins').get(0) as HTMLFormElement;
        var data = new FormData(formEditAdmins);
        data.append("editAdmin", "true");
        data.append("token", token);

        $.ajax({
            url: "/admin/admin/edit",
            method: "POST",
            data: data,
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function (response: ApiResponse) {
                console.log("response ", response);
                fncFormatInputs();
                matPreloader("off");

                if (response.status == 200) {
                    $(".table").DataTable().ajax.reload();
                    ($("#modalEdit") as any).modal("hide");
                    fncSweetAlertToast('success', response.message);
                } else {
                    fncSweetAlert("error", response.message, "");
                }
            }
        });
    });



    $('#formDispositivos').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        let formDispositivos = $('#formDispositivos').get(0) as HTMLFormElement;
        var data = new FormData(formDispositivos);
        const url = "/admin/dispositivo/create";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableDispositivos").DataTable().ajax.reload();
                ($("#AgregarDispositivo") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    $(document).on("click", "#tableDispositivos tbody .itemEdit", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        console.log("event ", event);
        start_loader();

        ($("#EditDispositivo") as any).modal("show");
        ($('#formEditDispositivo')[0] as HTMLFormElement).reset();
        $('#formEditDispositivo').removeClass("was-validated");

        let i = $(this).attr("i") ?? '';
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let url = "/admin/tables/get";

        editItem(url, table, suffix, i, function (response: ApiResponse) {
            end_loader();
            if (response.status == 200) {
                $("#i_d").val(response.data.id_device);
                $("#type_device").val(response.data.type_device);
                $("#mac_device").val(response.data.mac_device);
                $("#description_device").val(response.data.description_device);
            } else {
                fncSweetAlertToast('error', 'Datos no obtenidos actualizar la pagina o iniciar sesión nuevamente');
            }
        });
    });

    $('#formEditDispositivo').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        const token = localStorage.getItem("token_user") ?? "";
        let formEditDispositivo = $('#formEditDispositivo').get(0) as HTMLFormElement;
        var data = new FormData(formEditDispositivo);
        data.append("token", token);

        const url = "/admin/dispositivo/edit";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableDispositivos").DataTable().ajax.reload();
                ($("#EditDispositivo") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    /**
     * agregar cuenta
     */

    $(document).on("click", ".table tbody .dropdown-menu .verAccount", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const table = $(this).attr("table") ?? '';
        const suffix = $(this).attr("suffix") ?? '';
        const ipu = $(this).attr("ipu") ?? '';
        $("#btnAgregarCuenta").attr("ipu", ipu);

        const data = {
            "table": table,
            "suffix": suffix,
            "ipu": ipu
        };
        console.log("data ", data);
        initializeDataTable("#tableAccounts", "/admin/tables/accounts", data);
    });

    $(document).on("click", "#btnAgregarCuenta", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const ipu = $(this).attr("ipu") ?? '';
        $("input[name=ipu]").val(ipu);
        ($("#modalAgregarCuenta") as any).modal("show");
        ($('#formAccount')[0] as HTMLFormElement).reset();
        $('#formAccount').removeClass("was-validated");
    });

    $('#formAccount').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        let formAccount = $('#formAccount').get(0) as HTMLFormElement;
        var data = new FormData(formAccount);
        const url = "/admin/account/create";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableAccounts").DataTable().ajax.reload();
                ($("#modalAgregarCuenta") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    $(document).on("click", "#tableAccounts tbody .itemEdit", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        console.log("event ", event);
        start_loader();

        ($("#modalEditCuenta") as any).modal("show");
        ($('#formEditAccount')[0] as HTMLFormElement).reset();
        $('#formEditAccount').removeClass("was-validated");

        let i = $(this).attr("i") ?? '';
        let table = $(this).attr("table") ?? '';
        let suffix = $(this).attr("suffix") ?? '';
        let url = "/admin/tables/get";

        editItem(url, table, suffix, i, function (response: ApiResponse) {
            end_loader();
            if (response.status == 200) {
                $("#i_a").val(response.data.id_account);
                $("#username_account").val(response.data.username_account);
                $("#password_account").val(response.data.password_account);
                $("#expire_account").val(formatDate(response.data.expire_account));
                $("#bandwidth_down_account").val(response.data.bandwidth_down_account);
                $("#bandwidth_up_account").val(response.data.bandwidth_up_account);
                $("#description_account").val(response.data.description_account);
            } else {
                fncSweetAlertToast('error', 'Datos no obtenidos actualizar la pagina o iniciar sesión nuevamente');
            }
        });
    });

    $('#formEditAccount').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        const token = localStorage.getItem("token_user") ?? "";
        let formEditAccount = $('#formEditAccount').get(0) as HTMLFormElement;
        var data = new FormData(formEditAccount);
        data.append("token", token);

        const url = "/admin/account/edit";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableAccounts").DataTable().ajax.reload();
                ($("#modalEditCuenta") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });

    /**
     * Notificaiones
     */

    $(document).on("click", ".table tbody .dropdown-menu .verNotification", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const table = $(this).attr("table") ?? '';
        const suffix = $(this).attr("suffix") ?? '';
        const ipu = $(this).attr("ipu") ?? '';
        $("#btnEnviarNotification").attr("ipu", ipu);

        const data = {
            "table": table,
            "suffix": suffix,
            "ipu": ipu
        };
        console.log("data ", data);
        //initializeDataTable("#tableNotifications", "/tables/accounts", data);
    });

    $(document).on("click", "#btnEnviarNotification", function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();
        const ipu = $(this).attr("ipu") ?? '';
        $("input[name=ipu]").val(ipu);
        ($("#modalSendMessage") as any).modal("show");
        ($('#formSendMessage')[0] as HTMLFormElement).reset();
        $('#formSendMessage').removeClass("was-validated");
    });

    $('#formSendMessage').on('submit', function (e: JQuery.SubmitEvent) {
        e.preventDefault();
        matPreloader("on");
        start_loader();

        let formSendMessage = $('#formSendMessage').get(0) as HTMLFormElement;
        var data = new FormData(formSendMessage);
        const url = "/admin/client/send";

        submitData(url, data, function (response: ApiResponse) {
            end_loader();
            fncFormatInputs();
            matPreloader("off");

            if (response.status == 200) {
                $("#tableNotifications").DataTable().ajax.reload();
                ($("#modalSendMessage") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlertToast('error', response.message);
            }
        });
    });
});

function submitData(url: string, data: FormData, callback: (response: ApiResponse) => void) {
    $.ajax({
        url: url,
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: "json",
        success: function (resp: ApiResponse) {
            if (callback) {
                callback(resp);
            }
        },
        error: function (xhr: any, status: any, error: any) {
            console.error("Error en la solicitud:", error);
        },
    });
}

function editItem(url: string, table: string, suffix: string, i: string, callback: (response: ApiResponse) => void) {
    const token = localStorage.getItem("token_user") ?? "";
    var data = new FormData();
    data.append("i", i);
    data.append("table", table);
    data.append("suffix", suffix);
    data.append("editItem", "true");
    data.append("token", token);

    $.ajax({
        url: url,
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: "json",
        success: function (resp: ApiResponse) {
            if (callback) {
                callback(resp);
            }
        },
        error: function (xhr: any, status: any, error: any) {
            console.error("Error en la solicitud:", error);
        },
    });
}

function editRelItem(url: string, table1: string, suffix1: string, table2: string, suffix2: string, table3: string, suffix3: string, i: string, callback: (response: ApiResponse) => void) {
    const token = localStorage.getItem("token_user") ?? "";
    var data = new FormData();
    data.append("i", i);
    data.append("table1", table1);
    data.append("suffix1", suffix1);
    data.append("table2", table2);
    data.append("suffix2", suffix2);
    data.append("table3", table3);
    data.append("suffix3", suffix3);
    data.append("editItem", "true");
    data.append("token", token);

    $.ajax({
        url: url,
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: "json",
        success: function (resp: ApiResponse) {
            if (callback) {
                callback(resp);
            }
        },
        error: function (xhr: any, status: any, error: any) {
            console.error("Error en la solicitud:", error);
        },
    });
}

function deteleItem(table: string, suffix: string, i: string, dataTable: JQuery<HTMLElement>) {
    fncSweetAlert("confirm", "¿Esta seguro de eliminar el item?", null).then(resp => {
        let token = localStorage.getItem("token_user") ?? "";
        if (resp) {
            var data = new FormData();
            data.append("i", i);
            data.append("table", table);
            data.append("suffix", suffix);
            data.append("deleteItem", "true");
            data.append("token", token);

            $.ajax({
                url: "/admin/tables/delete",
                method: "POST",
                data: data,
                contentType: false,
                cache: false,
                processData: false,
                dataType: 'json',
                success: function (response: ApiResponse) {
                    console.log("response ", response);
                    if (response.status == 200) {
                        fncFormatInputs();
                        (dataTable as any).DataTable().ajax.reload(function () {
                            fncSweetAlertToast('success', 'Eliminado correctamente!');
                        });
                    } else {
                        fncSweetAlertToast('error', 'Error al eliminar, token expirado!');
                        fncFormatInputs();
                    }
                }
            });
        }
    });
}


/*=============================================
Capturar código telefónico
=============================================*/
$(document).on("change", ".changeCountry", function (this: HTMLElement) {
    $(".dialCode").html(($(this).val() as string).split("_")[1]);
});

function viewPass(event: Event) {
    const target = event.target as HTMLElement;
    const pass = document.querySelector('input[name="passwordLogin"]') as HTMLInputElement;
    if (pass.getAttribute("type") == "password") {
        pass.setAttribute("type", "text");
        target.classList.add("fa-eye");
        target.classList.remove("fa-eye-slash");
    } else {
        pass.setAttribute("type", "password");
        target.classList.remove("fa-eye");
        target.classList.add("fa-eye-slash");
    }
}

function limpiarUrl(texto: string): string {
    var texto = texto.toLowerCase();
    texto = texto.replace(/[á]/, 'a');
    texto = texto.replace(/[é]/, 'e');
    texto = texto.replace(/[í]/, 'i');
    texto = texto.replace(/[ó]/, 'o');
    texto = texto.replace(/[ú]/, 'u');
    texto = texto.replace(/[ñ]/, 'n');
    texto = texto.replace(/ /g, '-');
    return texto;
}

function myFunctionNew() {
    const t = document.getElementById("new-password") as HTMLInputElement;
    "password" === t.type ? t.type = "text" : t.type = "password";
    if ($('.ver-newpass').hasClass('fa-eye-slash')) {
        $('.ver-newpass').addClass('fa-eye').removeClass('fa-eye-slash');
    } else {
        $('.ver-newpass').addClass('fa-eye-slash').removeClass('fa-eye');
    }
}

function initializeDataTable(selector: string, ajaxUrl: string, additionalOptions: any = {}) {
    // Retornar silenciosamente si el elemento no existe
    if (!$(selector).length) {
        return null;
    }

    // Advertir solo si falta la librería de DataTables
    if (!$.fn.DataTable) {
        console.error(`DataTable not initialized: library not available`);
        return null;
    }

    const defaultOptions: DataTables.Settings = {
        responsive: true,
        lengthChange: true,
        aLengthMenu: [20, 50, 100, 500, 1000],
        autoWidth: true,
        processing: true,
        serverSide: false,
        retrieve: true,
        order: [[0, "desc"]],
        ajax: {
            url: ajaxUrl,
            type: "POST",
            data: {
                ajax: "true",
            },
        },
        language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Ningún dato disponible en esta tabla",
            sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_",
            sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0",
            sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
            sInfoPostFix: "",
            sSearch: "Buscar:",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "Siguiente",
                sPrevious: "Anterior",
            },
            oAria: {
                sSortAscending: ": Activar para ordenar la columna de manera ascendente",
                sSortDescending: ": Activar para ordenar la columna de manera descendente",
            },
        },
        /* buttons: [
             { extend: "csv" },
             { extend: "colvis" },
         ],*/
    };

    const options = $.extend(true, {}, defaultOptions, additionalOptions);
    const dataTable = $(selector).DataTable(options);

    $(selector).on("draw.dt", function () {
        setTimeout(function () {
            dataTable.buttons().container().appendTo(`${selector}_wrapper .col-md-6:eq(0)`);
            $(`${selector}_wrapper .col-md-6:eq(0)`).addClass("justify-content-between d-lg-flex");
        }, 100);
    });

    return dataTable;
}

(window as any).initializeActiveTables = function () {
    if ($.fn.DataTable) {
        // 1. tablePlans
        if ($('#tablePlans').length && !($.fn.DataTable as any).isDataTable('#tablePlans')) {
            initializeDataTable("#tablePlans", "/admin/tables/plans", {
                "columns": [
                    { "data": 0 }, { "data": 1 }, { "data": 2 }, { "data": 3 },
                    { "data": 4 }, { "data": 5 }, { "data": 6 }, { "data": 7 }
                ]
            });
        }

        // 2. tableClients
        if ($('#tableClients').length && !($.fn.DataTable as any).isDataTable('#tableClients')) {
            initializeDataTable("#tableClients", "/admin/tables/clients");
        }

        // 3. tablePropiedades
        if ($('#tablePropiedades').length && !($.fn.DataTable as any).isDataTable('#tablePropiedades')) {
            (window as any).tablePropiedades = initializeDataTable("#tablePropiedades", "/admin/tables/propiedades");
        }

        // 4. tableAdmins
        if ($('#tableAdmins').length && !($.fn.DataTable as any).isDataTable('#tableAdmins')) {
            initializeDataTable("#tableAdmins", "/admin/tables/admins");
        }

        // 5. tableMedidores
        if ($('#tableMedidores').length && !($.fn.DataTable as any).isDataTable('#tableMedidores')) {
            (window as any).tableMedidores = initializeDataTable("#tableMedidores", "/admin/tables/medidores", {
                "autoWidth": false,
                "ajax": {
                    "url": "/admin/tables/medidores",
                    "type": "POST",
                    "data": function (d: any) {
                        d.id_propiedad = (window as any).currentPropiedadId;
                        d.tipo_filtro_medidor = window.location.pathname.includes('/admin/energia') ? 'energia' : (window.location.pathname.includes('/admin/agua') ? 'agua' : (window.location.pathname.includes('/admin/gas') ? 'gas' : ''));
                    }
                }
            });
        }

        // 6. tableConsumos
        if ($('#tableConsumos').length && !($.fn.DataTable as any).isDataTable('#tableConsumos')) {
            tableConsumos = initializeDataTable("#tableConsumos", "/admin/tables/lecturas");
        }

        // 7. tableFacturasEmitidas — ahora se inicializa al seleccionar medidor en el flujo de 3 niveles

        // 8. tableConfigEnergia
        if ($('#tableConfigEnergia').length && !($.fn.DataTable as any).isDataTable('#tableConfigEnergia')) {
            initializeDataTable("#tableConfigEnergia", "/admin/tables/config-energia");
        }
    }

    // Datepickers
    if (($.fn as any).datepicker) {
        if ($('.expire_plan').length) {
            ($('.expire_plan') as any).datepicker({
                dateFormat: 'dd/mm/yy',
                dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                prevText: 'Anterior',
                nextText: 'Siguiente',
                currentText: 'Hoy',
                closeText: 'Cerrar',
                firstDay: 1,
                showMonthAfterYear: false,
                yearSuffix: '',
            });
        }

        if ($('.datepicker_portal').length) {
            ($('.datepicker_portal') as any).datepicker({
                dateFormat: 'dd M yy',
                dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                prevText: 'Anterior',
                nextText: 'Siguiente',
                currentText: 'Hoy',
                closeText: 'Cerrar',
                firstDay: 1,
                showMonthAfterYear: false,
                yearSuffix: '',
            });
        }
    }
    if (typeof (window as any).restoreLecturasStepState === 'function') {
        (window as any).restoreLecturasStepState();
    }
    if (typeof (window as any).restoreFacturacionStepState === 'function') {
        (window as any).restoreFacturacionStepState();
    }
};

function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}


/*=============================================
Verify Email Script
=============================================*/
$("#sendCodeVerify").on("click", function () {
    let email = ($("#newCodeVerify").val() as string);
    var data = new FormData();
    data.append("newCodeVerify", email);
    data.append("newEmailVerifiy", "true");

    $.ajax({
        url: "/newCodeVerify",
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        success: function (response) {
            console.log("response ", response);
            if (response == "200") {
                fncSweetAlert("success", "¡Código de verificación enviado a su correo " + email + ", confirme su cuenta  (verifique spam)!", "login");
                fncFormatInputs();
            } else {
                fncSweetAlert("error", "¡Su correo aun no esta registrado, registrarse para continuar!", "register");
                fncFormatInputs();
            }
        }
    });
});


/*=============================================
Portal Cautivo Accounts
=============================================*/
if ($("#tablePortal").length && $.fn.DataTable) {
    $("#tablePortal").DataTable({
        "responsive": true,
        "lengthChange": true,
        "aLengthMenu": [20, 50, 100, 500, 1000],
        "autoWidth": true,
        "processing": true,
        "serverSide": false, // Client side processing for now given custom API structure
        "retrieve": true,
        "order": [[0, "asc"]],
        "ajax": {
            url: "/admin/portal/list",
            type: "POST",
            data: {
                ajax: "true",
            },
            dataSrc: "data"
        },
        "columns": [
            { "data": "id" },
            { "data": "username" },
            { "data": "password" },
            { "data": "expiration" },
            { "data": "download" },
            { "data": "upload" },
            { "data": "acciones" },
        ],
        "language": {
            "sProcessing": "Procesando...",
            "sLengthMenu": "Mostrar _MENU_ registros",
            "sZeroRecords": "No se encontraron resultados",
            "sEmptyTable": "Ningún dato disponible en esta tabla",
            "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_",
            "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0",
            "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
            "sInfoPostFix": "",
            "sSearch": "Buscar:",
            "sUrl": "",
            "sInfoThousands": ",",
            "sLoadingRecords": "Cargando...",
            "oPaginate": {
                "sFirst": "Primero",
                "sLast": "Último",
                "sNext": "Siguiente",
                "sPrevious": "Anterior"
            },
            "oAria": {
                "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                "sSortDescending": ": Activar para ordenar la columna de manera descendente"
            }
        },
    });

    $("#tablePortal").on("draw.dt", function () {
        setTimeout(function () {
            let table = $('#tablePortal').DataTable();
            table.buttons().container().appendTo('#tablePortal_wrapper .col-md-6:eq(0)');
            $('#tablePortal_wrapper .col-md-6:eq(0)').addClass("justify-content-between d-lg-flex");
        }, 100);
    });
}

$("#formCreatePortal").on("submit", function (e: JQuery.SubmitEvent) {
    e.preventDefault();
    matPreloader("on");
    let form = $(this).get(0) as HTMLFormElement;
    let data = new FormData(form);

    $.ajax({
        url: "/admin/portal/create",
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: "json",
        success: function (response: any) {
            matPreloader("off");
            if (response.status == 200) {
                $("#tablePortal").DataTable().ajax.reload();
                ($("#modalCreatePortal") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
                form.reset();
            } else {
                fncSweetAlert("error", response.message, "");
            }
        }
    });
});

// Populate Edit Modal
$(document).on("click", "#tablePortal .itemEditPortal", function (e: JQuery.ClickEvent) {
    e.preventDefault();
    let username = $(this).attr("username");
    let password = $(this).attr("password");
    let expiration = $(this).attr("expiration");
    let expiration_id = $(this).attr("expiration_id");
    let download = $(this).attr("download");
    let download_id = $(this).attr("download_id");
    let upload = $(this).attr("upload");
    let upload_id = $(this).attr("upload_id");
    let password_id = $(this).attr("i"); // The main ID in this display is usually the password entry ID or username ID. Based on controller implementation, row ID is user ID.

    // Controller list() uses $user->id (which comes from the Cleartext-Password entry) as the main ID. 
    // So 'password_id' is effectively 'i'.

    $("#edit_username").val(username || "");
    $("#edit_username_hidden").val(username || "");
    $("#edit_password").val(password || "");
    $("#edit_password_id").val(password_id || "");

    $("#edit_expiration").val(expiration === 'Sin expiración' ? '' : expiration || "");
    $("#edit_expiration_id").val(expiration_id || "");

    $("#edit_download").val(download || "");
    $("#edit_download_id").val(download_id || "");

    $("#edit_upload").val(upload || "");
    $("#edit_upload_id").val(upload_id || "");

    ($("#modalEditPortal") as any).modal("show");
});

$("#formEditPortal").on("submit", function (e: JQuery.SubmitEvent) {
    e.preventDefault();
    matPreloader("on");
    let form = $(this).get(0) as HTMLFormElement;
    let data = new FormData(form);

    $.ajax({
        url: "/admin/portal/edit",
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: "json",
        success: function (response: any) {
            matPreloader("off");
            if (response.status == 200) {
                $("#tablePortal").DataTable().ajax.reload();
                ($("#modalEditPortal") as any).modal("hide");
                fncSweetAlertToast('success', response.message);
            } else {
                fncSweetAlert("error", response.message, "");
            }
        }
    });
});

$(document).on("click", "#tablePortal .itemDeletePortal", function (e: JQuery.ClickEvent) {
    e.preventDefault();
    let username = $(this).attr("username");

    fncSweetAlert("confirm", "¿Está seguro de eliminar este usuario y todos sus datos asociados (expiración, ancho de banda)?", null).then(resp => {
        if (resp) {
            matPreloader("on");
            let deleteItems = $(this).attr("delete-items");

            let data = new FormData();
            data.append("username", username || "");
            data.append("delete_items", deleteItems || "[]");

            $.ajax({
                url: "/admin/portal/delete",
                method: "POST",
                data: data,
                contentType: false,
                cache: false,
                processData: false,
                dataType: "json",
                success: function (response: any) {
                    matPreloader("off");
                    if (response.status == 200) {
                        $("#tablePortal").DataTable().ajax.reload();
                        fncSweetAlertToast('success', response.message);
                    } else {
                        fncSweetAlert("error", response.message, "");
                    }
                }
            });
        }
    });
});
/*=============================================
PROPIEDADES CRUD
=============================================*/
function reloadPropertiesList() {
    fetch(window.location.href)
        .then(res => res.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newLista = doc.getElementById('lista_propiedades');
            const oldLista = document.getElementById('lista_propiedades');
            if (newLista && oldLista) {
                oldLista.innerHTML = newLista.innerHTML;
            }

            const newTotal = doc.getElementById('total_propiedades');
            const oldTotal = document.getElementById('total_propiedades');
            if (newTotal && oldTotal) {
                oldTotal.innerHTML = newTotal.innerHTML;
            }

            // Recargar DataTables de Medidores si existe
            if (typeof (window as any).tableMedidores !== 'undefined' && (window as any).tableMedidores) {
                (window as any).tableMedidores.ajax.reload(null, false);
            }
        })
        .catch(error => console.error('Error reloading properties:', error));
}

// ==========================================
// INICIALIZACIÓN DE MEDIDORES (DATATABLES)
// ==========================================
{
    const urlParams = new URLSearchParams(window.location.search);
    (window as any).currentPropiedadId = urlParams.get('propiedad') || urlParams.get('id_propiedad') || $('#id_propiedad_add').val() || ($('.propiedad-item.active').length ? $('.propiedad-item.active').attr('data-id') : null);
}

if ($('#tableMedidores').length) {
    (window as any).tableMedidores = initializeDataTable("#tableMedidores", "/admin/tables/medidores", {
        "autoWidth": false,
        "ajax": {
            "url": "/admin/tables/medidores",
            "type": "POST",
            "data": function (d: any) {
                d.id_propiedad = (window as any).currentPropiedadId;
                d.tipo_filtro_medidor = window.location.pathname.includes('/admin/energia') ? 'energia' : (window.location.pathname.includes('/admin/agua') ? 'agua' : (window.location.pathname.includes('/admin/gas') ? 'gas' : ''));
            }
        }
    });

    // Click en la lista de propiedades de la izquierda
    $(document).on('click', '.propiedad-item', function () {
        $('.propiedad-item').removeClass('bg-light-info active border-transparent').addClass('border-transparent hover-border-primary text-gray-600');
        $('.propiedad-item i.fa-home').removeClass('fa-home text-info').addClass('fa-building text-gray-400');
        $('.propiedad-item span.badge').removeClass('badge-light-primary');
        $('.propiedad-item span.badge i').removeClass('text-primary').addClass('text-gray-500');

        $(this).removeClass('border-transparent hover-border-primary text-gray-600').addClass('bg-light-info active border-transparent');
        $(this).find('i.fa-building').removeClass('fa-building text-gray-400').addClass('fa-home text-info');
        $(this).find('span.badge').addClass('badge-light-primary');
        $(this).find('span.badge i').removeClass('text-gray-500').addClass('text-primary');

        (window as any).currentPropiedadId = $(this).attr('data-id') || '';

        // Recargar DataTable de medidores
        if ((window as any).tableMedidores) {
            (window as any).tableMedidores.ajax.reload();
        }
    });
}

/*=============================================
CONSUMOS CRUD
=============================================*/
// Inicializar tabla
var tableConsumos: any = null;
if ($('#tableConsumos').length) {
    tableConsumos = initializeDataTable("#tableConsumos", "/admin/tables/lecturas");

    // Opcional: Filtro por mes (si el usuario elige del dropdown)
    $('#filtro_mes_consumo').on('change', function () {
        // Se puede implementar en el backend y enviar d.mes_filtro
        // tableConsumos.ajax.reload();
    });
}

// Autocompletar "Lectura Anterior" al seleccionar Medidor en "Añadir Consumo"
$('#id_medidor_consumo').on('change', function () {
    const idMedidor = $(this).val();
    if (idMedidor) {
        const formData = new FormData();
        formData.append('id_medidor', idMedidor.toString());
        const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
        formData.append('tipo_servicio_consumo', serviceType);

        fetch('/admin/lecturas/last', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    $('[name="lectura_anterior_consumo"]').val(data.lectura_anterior);
                } else {
                    $('[name="lectura_anterior_consumo"]').val('0.00');
                }
            })
            .catch(error => {
                console.error("Error al obtener la lectura anterior", error);
                $('[name="lectura_anterior_consumo"]').val('0.00');
            });
    }
});

// Nuevo Consumo
var btnGuardarConsumo = document.getElementById('btnGuardarConsumo');
if (btnGuardarConsumo) {
    btnGuardarConsumo.addEventListener('click', function (e) {
        e.preventDefault();
        const form = document.getElementById('formAddConsumo') as HTMLFormElement;

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const formData = new FormData(form);
        const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
        formData.append('tipo_servicio_consumo', serviceType);

        fetch('/admin/lecturas/create', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') {
                        fncSweetAlertToast('success', data.message || 'Lectura registrada');
                    }
                    ($('#modal_add_consumo') as any).modal('hide');
                    form.reset();
                    // Resetear selects si usan select2
                    if ($('#id_medidor_consumo').hasClass('select2-hidden-accessible')) {
                        $('#id_medidor_consumo').val(null).trigger('change');
                    }
                    if (tableConsumos) tableConsumos.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') {
                        fncSweetAlertToast('error', data.message || 'Error al guardar');
                    } else {
                        alert(data.message || 'Error al guardar');
                    }
                }
            })
            .catch(error => console.error('Error:', error));
    });
}

// Modal Editar Consumo
$(document).on('click', '.btn-edit-consumo', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    const id = $(this).attr('data-id') || '';
    const idMedidor = $(this).attr('data-id-medidor') || '';
    const fecha = $(this).attr('data-fecha') || '';
    const fechaAnterior = $(this).attr('data-fecha-anterior') || '';
    const anterior = $(this).attr('data-anterior') || '0.00';
    const actual = $(this).attr('data-actual') || '0.00';

    // Aseguramos formato YYYY-MM-DDTHH:MM:SS para datetime-local (ahora con step="1")
    const fAct = fecha ? fecha.replace(' ', 'T') : '';
    const fAnt = fechaAnterior ? fechaAnterior.replace(' ', 'T') : '';

    $('#edit_id_consumo').val(id);
    $('#edit_id_medidor_consumo').val(idMedidor);
    $('#edit_fecha_lectura_consumo').val(fAct);
    $('#edit_fecha_lectura_anterior_consumo').val(fAnt);
    $('#edit_lectura_anterior_consumo').val(anterior);
    $('#edit_lectura_actual_consumo').val(actual);
    updateConsumptionPreview('#edit_lectura_actual_consumo', '#edit_lectura_anterior_consumo', '#edit_consumo_preview');

    // Update edit last reading info dynamically
    if (fechaAnterior) {
        const dateParts = fechaAnterior.split(' ');
        const dateYMD = dateParts[0].split('-');
        const formattedDate = dateYMD[2] + '/' + dateYMD[1] + '/' + dateYMD[0] + (dateParts[1] ? ' ' + dateParts[1] : '');

        $('#edit_last_reading_val').text(parseFloat(anterior).toFixed(2) + ' ' + activeSufijo);
        $('#edit_last_reading_date').text(formattedDate);
        $('#edit_last_reading_info').show();
    } else {
        $('#edit_last_reading_val').text('0.00 ' + activeSufijo);
        $('#edit_last_reading_date').text('Primera lectura (Línea Base)');
        $('#edit_last_reading_info').show();
    }

    ($('#modal_edit_consumo') as any).modal('show');
});


// Guardar Edición Consumo
$(document).on('submit', '#formEditConsumo', function (e) {
    e.preventDefault();
    const form = this as HTMLFormElement;
    const formData = new FormData(form);
    const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
    formData.append('tipo_servicio_consumo', serviceType);

    fetch('/admin/lecturas/edit', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if (data.status === 200) {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message || 'Lectura editada');
                ($('#modal_edit_consumo') as any).modal('hide');

                // Refrescar historial si estamos en la vista de gestión
                const currentMeterId = $('#history_id_medidor').val();
                if (currentMeterId) {
                    loadMeterHistory(currentMeterId.toString());
                }

                // Refrescar tabla general si existe (para otras vistas)
                // @ts-ignore
                if (typeof tableConsumos !== 'undefined' && tableConsumos) tableConsumos.ajax.reload();
            } else {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message || 'Error al editar');
            }
        });
});
// Eliminar Consumo
$(document).on('click', '.btn-delete-consumo', function (e: JQuery.ClickEvent) {
    e.stopPropagation();
    const id = $(this).attr('data-id');
    const tokenUser = localStorage.getItem("token_user") ?? "";

    fncSweetAlert("confirm", "¿Estás seguro de que deseas eliminar esta lectura?", null).then(resp => {
        if (resp) {
            const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
            const formData = new FormData();
            formData.append('table', 'lectura_medidores_' + serviceType);
            formData.append('i', id || '');
            formData.append('suffix', 'lectura');
            formData.append('token', tokenUser);

            fetch('/admin/tables/delete', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 200) {
                        if (typeof fncSweetAlertToast === 'function') {
                            fncSweetAlertToast('success', 'Lectura eliminada correctamente');
                        }
                        if (typeof tableConsumos !== 'undefined' && tableConsumos) {
                            tableConsumos.ajax.reload(null, false);
                        } else if ($("#tableConsumos").length) {
                            $("#tableConsumos").DataTable().ajax.reload(null, false);
                        }

                        // Refrescar historial del medidor si el modal está abierto
                        const historyMeterId = $('#history_id_medidor').val();
                        if (historyMeterId) {
                            loadMeterHistory(historyMeterId.toString());
                        }
                    } else {
                        if (typeof fncSweetAlertToast === 'function') {
                            fncSweetAlertToast('error', 'Error al eliminar el consumo');
                        }
                    }
                })
                .catch(error => console.error('Error:', error));
        }
    });
});

// Aprobar Lectura Virtual
$(document).on('click', '.btn-aprobar-virtual', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    e.stopPropagation();

    const btn = $(this);
    const idMedidor = btn.data('id-medidor');
    const idPropiedad = btn.data('id-propiedad');
    const fecha = btn.data('fecha');
    const actual = btn.data('actual');
    const servicio = btn.data('servicio') || 'energia';

    btn.prop('disabled', true).text('Aprobando...');

    const formData = new FormData();
    formData.append('id_medidor_consumo', idMedidor);
    formData.append('id_propiedad_consumo', idPropiedad);
    formData.append('fecha_lectura_consumo', fecha);
    formData.append('lectura_actual_consumo', actual);
    formData.append('tipo_servicio_consumo', servicio);
    formData.append('tipo_lectura', 'virtual');

    fetch('/admin/lecturas/create', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if (data.status === 200) {
                if (typeof fncSweetAlertToast === 'function') {
                    fncSweetAlertToast('success', 'Lectura virtual aprobada');
                }
                if ($("#table_history_medidor").length) {
                    $("#table_history_medidor").DataTable().ajax.reload(null, false);
                }
            } else {
                if (typeof fncSweetAlertToast === 'function') {
                    fncSweetAlertToast('error', data.message || 'Error al aprobar lectura');
                }
                btn.prop('disabled', false).text('Aprobar');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            btn.prop('disabled', false).text('Aprobar');
        });
});


/*=============================================
FACTURACIÓN EMITIDA CRUD
=============================================*/
var tableFacturasEmitidas: any = null;
var factCurrentProperty: { id: string; name: string; suministro: string } = { id: '', name: '', suministro: '' };
var factCurrentService: string = '';
var factCurrentMeter: { id: string; name: string; codigo: string } = { id: '', name: '', codigo: '' };

type FactLevel = 'properties' | 'services' | 'meters' | 'invoices';

function showFactLevel(step: FactLevel) {
    const levels: Record<FactLevel, string> = {
        properties: '#fact-level-properties',
        services: '#fact-level-services',
        meters: '#fact-level-meters',
        invoices: '#fact-level-invoices'
    };
    Object.entries(levels).forEach(([key, selector]) => {
        const level = $(selector);
        if (key === step) {
            level.removeClass('d-none is-leaving').addClass('is-entering');
            setTimeout(() => level.removeClass('is-entering'), 320);
        } else if (!level.hasClass('d-none')) {
            level.addClass('is-leaving');
            setTimeout(() => level.addClass('d-none').removeClass('is-leaving'), 220);
        }
    });
    $('.fact-chip').removeClass('active');
    $(`.fact-chip[data-fact-step="${step}"]`).addClass('active');
}

function renderFactMetersList(idProp: string, serviceType: string) {
    const factData = (window as any).factData || {};
    const allMeds: any[] = factData.medidoresPorPropiedad?.[idProp] || [];
    const medidores = allMeds.filter((m: any) => (m.tipo_servicio || 'energia') === serviceType);
    const svcCfg = factData.serviceConfig?.[serviceType] || { icon: 'fa-bolt', gradient: 'linear-gradient(135deg,#f6c343,#f59e0b)' };
    let html = '';
    $('#fact-meter-count').text(`${medidores.length} medidor${medidores.length === 1 ? '' : 'es'}`);
    $('#factMeterSearch').val('');

    if (medidores.length > 0) {
        medidores.forEach((med: any) => {
            const tipo = med.tipo_medidor || 'Sub-medidor';
            const dataSearch = `${med.nombre_medidor || ''} ${med.codigo_medidor || ''} ${tipo}`.toLowerCase();
            html += `
                <div class="col-md-4 col-xl-3 fact-meter-item" data-search="${dataSearch}">
                    <div class="fact-card card h-100 cursor-pointer btn-fact-select-meter"
                          data-id="${med.id_medidor}" data-nombre="${med.nombre_medidor}" data-tipo="${tipo}" data-codigo="${med.codigo_medidor || ''}">
                        <div class="card-body d-flex flex-column p-7">
                            <div class="d-flex align-items-center gap-3 mb-5">
                                <div style="width:40px;height:40px;border-radius:10px;background:${svcCfg.gradient};display:flex;align-items:center;justify-content:center">
                                    <i class="fas ${svcCfg.icon}" style="color:#fff;font-size:1rem"></i>
                                </div>
                                <div class="flex-grow-1 min-w-0">
                                    <div class="fw-bold fs-6 text-truncate" style="color:var(--text-primary)">${med.nombre_medidor}</div>
                                    <div class="fw-semibold fs-7" style="color:var(--text-muted)">${tipo}</div>
                                </div>
                            </div>
                            <div class="d-flex flex-stack mt-auto pt-3" style="border-top:1px solid var(--border-light)">
                                <span class="fact-badge fact-badge--count">SN: ${med.codigo_medidor || 'S/N'}</span>
                                <i class="fas fa-chevron-right" style="color:var(--text-muted)"></i>
                            </div>
                        </div>
                    </div>
                </div>`;
        });
    } else {
        html = '<div class="col-12"><div style="background:rgba(0,217,192,.06);border:1px dashed rgba(0,217,192,.2);border-radius:12px;padding:20px;text-align:center;color:var(--text-muted)">No hay medidores de este servicio en la propiedad.</div></div>';
    }
    $('#fact-meters-grid').html(html);
}

function renderFactServiceCards(idProp: string) {
    const factData = (window as any).factData || {};
    const servicios: string[] = factData.serviciosPorPropiedad?.[idProp] || [];
    const svcConfig = factData.serviceConfig || {};
    let html = '';

    if (servicios.length === 0) {
        html = '<div class="col-12"><div style="background:rgba(246,195,67,.06);border:1px dashed rgba(246,195,67,.25);border-radius:12px;padding:20px;text-align:center;color:var(--text-muted)">No hay servicios configurados para esta propiedad.</div></div>';
    } else {
        servicios.forEach((svc: string) => {
            const cfg = svcConfig[svc] || { label: svc, icon: 'fa-bolt', gradient: 'linear-gradient(135deg,#ccc,#eee)' };
            const allMeds: any[] = factData.medidoresPorPropiedad?.[idProp] || [];
            const count = allMeds.filter((m: any) => (m.tipo_servicio || 'energia') === svc).length;
            html += `
            <div class="col-md-4 col-lg-3">
                <div class="fact-svc-card card h-100 btn-fact-select-svc" data-service="${svc}">
                    <div class="card-body d-flex flex-column align-items-center text-center p-8">
                        <div class="fact-svc-card__icon mb-5" style="background:${cfg.gradient}">
                            <i class="fas ${cfg.icon}"></i>
                        </div>
                        <h4 class="fw-bolder mb-1" style="color:var(--text-primary)">${cfg.label}</h4>
                        <span class="fs-7 mb-4" style="color:var(--text-muted)">${count} medidor${count === 1 ? '' : 'es'}</span>
                        <span class="mt-auto px-4 py-2 fw-bold" style="background:rgba(0,217,192,.1);color:var(--accent-cyan);border-radius:8px;font-size:.82rem">Seleccionar <i class="fas fa-arrow-right ms-1 fs-9"></i></span>
                    </div>
                </div>
            </div>`;
        });
    }
    $('#fact-svc-grid').html(html);
}

function initFacturasTable(idMedidor: string) {
    if (tableFacturasEmitidas && ($.fn.DataTable as any).isDataTable('#tableFacturasEmitidas')) {
        tableFacturasEmitidas.ajax.url("/admin/tables/facturas-emitidas?id_medidor=" + idMedidor).load();
        return;
    }
    tableFacturasEmitidas = initializeDataTable("#tableFacturasEmitidas", "/admin/tables/facturas-emitidas?id_medidor=" + idMedidor, {
        "autoWidth": false,
        "columns": [
            { "data": 0 },
            { "data": 1 },
            { "data": 2 },
            { "data": 3 },
            { "data": 4 },
            { "data": 5 },
            { "data": 6 }
        ]
    });
}

function resetFacturaPreview(message: string = 'Aún no se ha cargado ninguna lectura para facturar.', resetConsumos: boolean = true) {
    $('#factura_emitida_consumo_id').val('');
    $('#form_add_factura_emitida button[type="submit"]').prop('disabled', false);
    $('#factura_emitida_fecha_emision').val('');
    $('#factura_emitida_fecha_vencimiento').val('');
    $('#facturaPreviewContent').html(`<div class="text-muted fs-7">${message}</div>`);
    if (resetConsumos) {
        $('#facturaConsumosPeriodoContent').html('<div class="text-muted fs-7">Seleccione propiedad, medidor y periodo para listar los consumos disponibles.</div>');
    }
}

function renderFacturaPreview(preview: any) {
    const otrosCargos = Array.isArray(preview.otros_cargos) ? preview.otros_cargos : [];
    const prefijoMoneda = preview.prefijo_moneda || 'S/';
    const cargosRows = otrosCargos.length
        ? otrosCargos.map((cargo: any) => `
            <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-gray-200">
                <span class="text-gray-700 fs-7">${cargo.nombre || 'Cargo'}${cargo.unidad ? ` <span class="text-muted">(${cargo.valor} ${cargo.unidad})</span>` : ''}</span>
                <span class="fw-semibold text-gray-900">${prefijoMoneda} ${Number(cargo.monto || 0).toFixed(2)}</span>
            </div>
        `).join('')
        : `<div class="text-muted fs-7">No hay cargos adicionales configurados para esta propiedad.</div>`;

    const badge = `<span class="badge badge-light-success mb-4">Consumo listo para emisión</span>`;

    // Dynamic service-aware labels and units
    let unidadLabel = 'kWh';
    let servicioLabel = 'Energía activa';
    if (preview.tipo_servicio === 'agua') {
        unidadLabel = 'm³';
        servicioLabel = 'Consumo de Agua';
    } else if (preview.tipo_servicio === 'gas') {
        unidadLabel = 'm³';
        servicioLabel = 'Consumo de Gas';
    }

    $('#form_add_factura_emitida button[type="submit"]').prop('disabled', false);
    $('#factura_emitida_fecha_emision').val(preview.fecha_emision || '');
    $('#factura_emitida_fecha_vencimiento').val(preview.fecha_vencimiento || '');

    $('#facturaPreviewContent').html(`
        ${badge}
        <div class="row g-5 mb-5">
            <div class="col-md-6">
                <div class="bg-white rounded border px-4 py-3 h-100">
                    <div class="fw-bold text-gray-900 mb-2">${preview.propiedad_nombre || 'Sin propiedad'}</div>
                    <div class="text-muted fs-7 mb-1">${preview.propiedad_direccion || ''}</div>
                    <div class="text-gray-700 fs-7">Cliente: <span class="fw-semibold">${preview.cliente_nombre || 'Sin cliente'}</span></div>
                    <div class="text-gray-700 fs-7">Documento: <span class="fw-semibold">${preview.cliente_documento || '-'}</span></div>
                    <div class="text-gray-700 fs-7">Suministro: <span class="fw-semibold">${preview.suministro || '-'}</span></div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="bg-white rounded border px-4 py-3 h-100">
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Fecha lectura</span><span class="fw-semibold">${preview.fecha_lectura || '-'}</span></div>
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Fecha emisión</span><span class="fw-semibold">${preview.fecha_emision || '-'}</span></div>
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Fecha vencimiento</span><span class="fw-semibold">${preview.fecha_vencimiento || '-'}</span></div>
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Fecha corte</span><span class="fw-semibold">${preview.fecha_corte || '-'}</span></div>
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Lectura anterior</span><span class="fw-semibold">${Number(preview.lectura_anterior || 0).toFixed(2)}</span></div>
                    <div class="d-flex justify-content-between fs-7 mb-2"><span>Lectura actual</span><span class="fw-semibold">${Number(preview.lectura_actual || 0).toFixed(2)}</span></div>
                    <div class="d-flex justify-content-between fs-7"><span>Consumo</span><span class="fw-bolder text-primary">${Number(preview.consumo_total || 0).toFixed(2)} ${unidadLabel}</span></div>
                </div>
            </div>
        </div>
        <div class="bg-white rounded border px-4 py-4">
            <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-gray-200">
                <span class="text-gray-700 fs-7">${servicioLabel} (${Number(preview.consumo_total || 0).toFixed(2)} ${unidadLabel} x ${prefijoMoneda} ${Number(preview.precio_unitario || 0).toFixed(4)})</span>
                <span class="fw-semibold text-gray-900">${prefijoMoneda} ${Number(preview.subtotal || 0).toFixed(2)}</span>
            </div>
            ${cargosRows}
            <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-gray-200">
                <span class="text-gray-700 fs-7">${preview.impuesto_nombre || 'Impuesto'} (${Number(preview.impuesto_porcentaje || 0).toFixed(2)}%)</span>
                <span class="fw-semibold text-gray-900">${prefijoMoneda} ${Number(preview.impuesto_monto || 0).toFixed(2)}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center pt-3">
                <span class="fw-bold text-gray-900">Total</span>
                <span class="fw-bolder text-primary fs-4">${prefijoMoneda} ${Number(preview.total || 0).toFixed(2)}</span>
            </div>
        </div>
    `);
}

function loadFacturaPreview() {
    const idConsumo = String($('#factura_emitida_consumo_id').val() || '');
    const manualAnt = String($('#manual_lectura_anterior').val() || '');
    const manualAct = String($('#manual_lectura_actual').val() || '');
    const manualFecha = String($('#manual_fecha_lectura').val() || '');

    const hasManual = manualAnt && manualAct;

    if (!idConsumo && !hasManual) {
        resetFacturaPreview('Seleccione un consumo del periodo o ingrese lecturas manuales para calcular la factura.', false);
        return;
    }

    const formData = new FormData();
    formData.append('id_consumo', idConsumo);

    if (hasManual) {
        formData.append('manual_lectura_anterior', manualAnt);
        formData.append('manual_lectura_actual', manualAct);
        if (manualFecha) formData.append('manual_fecha_lectura', manualFecha);
    }

    const precioManual = String($('#manual_precio_unitario').val() || '');
    if (precioManual) {
        formData.append('precio_unitario_manual', precioManual);
    }

    // Siempre enviar los parámetros de periodo en caso de que previewFacturaEmitida los requiera globalmente
    formData.append('id_medidor_origen', String(factCurrentMeter.id || ''));
    formData.append('periodo_anio', String($('#factura_emitida_year_select').val() || ''));
    formData.append('periodo_mes', String($('#factura_emitida_month_select').val() || ''));
    formData.append('tipo_servicio', factCurrentService);

    $('#facturaPreviewContent').html('<div class="text-primary fs-7">Calculando factura con tarifas e impuestos de la propiedad...</div>');

    fetch('/admin/facturacion/preview', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            if (data.status === 200 && data.preview) {
                renderFacturaPreview(data.preview);
            } else {
                resetFacturaPreview(data.message || 'No se pudo calcular la factura para el consumo seleccionado.', false);
            }
        })
        .catch(error => {
            console.error('Error generando vista previa de factura:', error);
            resetFacturaPreview('Ocurrió un error al generar la vista previa de la factura.', false);
        });
}

function renderConsumosPeriodo(consumos: any[]) {
    if (!Array.isArray(consumos) || !consumos.length) {
        $('#facturaConsumosPeriodoContent').html('<div class="text-muted fs-7">No hay consumos disponibles en ese periodo.</div>');
        $('#factura_emitida_consumo_id').val('0');
        $('#manual_lectura_anterior').val('');
        $('#manual_lectura_actual').val('');
        resetFacturaPreview('Ingrese lecturas manuales para continuar.', false);
        return;
    }

    // Poblar selects manuales recopilando todas las lecturas de los consumos y de sus objetos "anterior"
    $('#manual_lectura_anterior').empty();
    $('#manual_lectura_actual').empty();

    const todasLasLecturas: { val: string, fecha: string }[] = [];

    consumos.forEach(c => {
        todasLasLecturas.push({ val: Number(c.lectura_actual || 0).toFixed(2), fecha: c.fecha_lectura || '' });
        if (c.lectura_anterior_obj) {
            todasLasLecturas.push({ val: Number(c.lectura_anterior_obj.lectura_actual || 0).toFixed(2), fecha: c.lectura_anterior_obj.fecha_lectura || c.fecha_lectura_anterior || '' });
        } else if (c.lectura_anterior) {
            todasLasLecturas.push({ val: Number(c.lectura_anterior || 0).toFixed(2), fecha: c.fecha_lectura_anterior || 'Calculada/Manual' });
        }
    });

    // Eliminar duplicados para tener opciones limpias
    const lecturasUnicas = Array.from(new Map(todasLasLecturas.map(item => [item.val + '-' + item.fecha, item])).values());

    // Ordenar cronológicamente (más recientes primero)
    lecturasUnicas.sort((a, b) => b.fecha.localeCompare(a.fecha));

    lecturasUnicas.forEach(lect => {
        const optionHtml = `<option value="${lect.val}" data-fecha="${lect.fecha.split(' ')[0]}">Lectura: ${lect.val} (${lect.fecha})</option>`;
        $('#manual_lectura_anterior').append(optionHtml);
        $('#manual_lectura_actual').append(optionHtml);
    });

    const firstConsumo = consumos[0];
    if (firstConsumo) {
        // Seleccionar los valores correspondientes al primer consumo
        let antVal = '';
        if (firstConsumo.lectura_anterior_obj) {
            antVal = Number(firstConsumo.lectura_anterior_obj.lectura_actual || 0).toFixed(2);
        } else {
            antVal = Number(firstConsumo.lectura_anterior || 0).toFixed(2);
        }
        $('#manual_lectura_anterior').val(antVal);

        const actVal = Number(firstConsumo.lectura_actual || 0).toFixed(2);
        $('#manual_lectura_actual').val(actVal);

        if (firstConsumo.fecha_lectura) {
            const fechaParts = String(firstConsumo.fecha_lectura).split(' ')[0];
            $('#manual_fecha_lectura').val(fechaParts);
        }
    }

    const rows = consumos.map((consumo: any, index: number) => {
        const checked = index === 0 ? 'checked' : '';
        return `
            <label class="border rounded p-4 d-flex align-items-start gap-3 mb-3 cursor-pointer bg-white">
                <input class="form-check-input mt-1 factura-consumo-option" type="radio" name="factura_consumo_option" value="${consumo.id_lectura}" ${checked}>
                <div class="flex-grow-1">
                    <div class="fw-bold text-gray-900 mb-1">Lectura ${consumo.fecha_lectura || '-'}</div>
                    <div class="row g-3 fs-7 text-gray-700">
                        <div class="col-md-3">Anterior: <span class="fw-semibold">${Number(consumo.lectura_anterior || 0).toFixed(2)}</span></div>
                        <div class="col-md-3">Actual: <span class="fw-semibold">${Number(consumo.lectura_actual || 0).toFixed(2)}</span></div>
                        <div class="col-md-3">Consumo: <span class="fw-semibold text-primary">${Number(consumo.consumo_total || 0).toFixed(2)} kWh</span></div>
                        <div class="col-md-3">Estado: <span class="fw-semibold">${consumo.estado_pago || 'pendiente'}</span></div>
                    </div>
                </div>
            </label>
        `;
    }).join('');

    $('#facturaConsumosPeriodoContent').html(rows);
    const firstValue = String(consumos[0].id_lectura || '');
    $('#factura_emitida_consumo_id').val(firstValue);
    loadFacturaPreview();
}

function loadConsumosPeriodoFacturacion() {
    const idMedidor = factCurrentMeter.id;
    const year = String($('#factura_emitida_year_select').val() || '');
    const month = String($('#factura_emitida_month_select').val() || '');

    if (!idMedidor || !year || !month) {
        resetFacturaPreview('Seleccione año y mes para calcular la factura.');
        return;
    }

    const formData = new FormData();
    formData.append('id_medidor', idMedidor);
    formData.append('year', year);
    formData.append('month', month);
    formData.append('tipo_servicio', factCurrentService);

    $('#factura_emitida_consumo_id').val('');
    $('#manual_lectura_anterior').val('');
    $('#manual_lectura_actual').val('');
    $('#facturaConsumosPeriodoContent').html('<div class="text-info fs-7">Buscando consumos del periodo seleccionado...</div>');
    $('#facturaPreviewContent').html('<div class="text-muted fs-7">Seleccione un consumo del periodo para ver el cálculo.</div>');

    fetch('/admin/facturacion/lecturas-periodo', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            if (data.status === 200 && Array.isArray(data.results)) {
                renderConsumosPeriodo(data.results);
            } else if (data.status === 409) {
                resetFacturaPreview(data.message || 'Ya existe una factura emitida para este periodo.');
                fncSweetAlert('warning', data.message || 'Ya existe una factura emitida para este periodo.', '');
            } else {
                resetFacturaPreview(data.message || 'No se pudieron listar los consumos del periodo.');
            }
        })
        .catch(error => {
            console.error('Error consultando consumos del periodo:', error);
            resetFacturaPreview('Ocurrió un error al consultar los consumos del periodo.');
        });
}

// ===================== FACTURACIÓN: NAVEGACIÓN 4 NIVELES =====================

function updateFactUrlParams(propiedad: string | null, servicio: string | null, medidor: string | null) {
    const url = new URL(window.location.href);
    if (propiedad) { url.searchParams.set('propiedad', propiedad); } else { url.searchParams.delete('propiedad'); }
    if (servicio) { url.searchParams.set('servicio', servicio); } else { url.searchParams.delete('servicio'); }
    if (medidor) { url.searchParams.set('medidor', medidor); } else { url.searchParams.delete('medidor'); }
    window.history.replaceState({}, '', url.toString());
}

// Nivel 1 → Nivel 2: Seleccionar Propiedad → mostrar Servicios
$(document).on('click', '.btn-fact-select-prop', function () {
    const idProp = $(this).attr('data-id') || '';
    const nombreProp = $(this).attr('data-nombre') || 'Propiedad';
    const suministroProp = $(this).attr('data-suministro') || idProp;
    factCurrentProperty = { id: idProp, name: nombreProp, suministro: suministroProp };
    $('#fact-svc-title').text(`Servicios en: ${nombreProp}`);
    renderFactServiceCards(idProp);
    showFactLevel('services');
    updateFactUrlParams(suministroProp, null, null);
});

// Nivel 2 → Nivel 1: Volver a propiedades
$(document).on('click', '.btn-fact-back-props', function () {
    showFactLevel('properties');
    updateFactUrlParams(null, null, null);
});

// Nivel 2 → Nivel 3: Seleccionar Servicio → mostrar Medidores
$(document).on('click', '.btn-fact-select-svc', function () {
    const svc = $(this).attr('data-service') || 'energia';
    factCurrentService = svc;
    const factData = (window as any).factData || {};
    const svcCfg = factData.serviceConfig?.[svc] || { label: svc };
    $('#fact-meter-title').text(`Medidores de ${svcCfg.label}: ${factCurrentProperty.name}`);
    renderFactMetersList(factCurrentProperty.id, svc);
    showFactLevel('meters');
    updateFactUrlParams(factCurrentProperty.suministro, svc, null);
});

// Nivel 3 → Nivel 2: Volver a servicios
$(document).on('click', '.btn-fact-back-svcs', function () {
    showFactLevel('services');
    updateFactUrlParams(factCurrentProperty.suministro, null, null);
});

// Nivel 3 → Nivel 4: Seleccionar Medidor → mostrar Facturas
$(document).on('click', '.btn-fact-select-meter', function () {
    const idMed = $(this).attr('data-id') || '';
    const nombreMed = $(this).attr('data-nombre') || 'Medidor';
    const codigoMed = $(this).attr('data-codigo') || idMed;
    factCurrentMeter = { id: idMed, name: nombreMed, codigo: codigoMed };
    const factData = (window as any).factData || {};
    const svcCfg = factData.serviceConfig?.[factCurrentService] || { label: factCurrentService };
    $('#fact-inv-title').text(`Facturas: ${nombreMed}`);
    $('#fact-inv-subtitle').text(`${svcCfg.label} · SN: ${codigoMed}`);
    $('#fact-inv-path').text(`${factCurrentProperty.name} / ${svcCfg.label} / ${nombreMed}`);
    initFacturasTable(idMed);
    showFactLevel('invoices');
    updateFactUrlParams(factCurrentProperty.suministro, factCurrentService, codigoMed);
});

// Nivel 4 → Nivel 3: Volver a medidores
$(document).on('click', '.btn-fact-back-meters', function () {
    showFactLevel('meters');
    updateFactUrlParams(factCurrentProperty.suministro, factCurrentService, null);
});

// Búsqueda de propiedades
$(document).on('input', '#factPropSearch', function () {
    const query = String($(this).val() || '').toLowerCase();
    $('.fact-prop-item').each(function () {
        $(this).toggle(($(this).attr('data-search') || '').includes(query));
    });
});

// Búsqueda de medidores
$(document).on('input', '#factMeterSearch', function () {
    const query = String($(this).val() || '').toLowerCase();
    $('.fact-meter-item').each(function () {
        $(this).toggle(($(this).attr('data-search') || '').includes(query));
    });
});

// ===================== FACTURACIÓN: MODAL EMITIR =====================

$(document).on('show.bs.modal', '#modal_add_factura_emitida', function () {
    ($('#form_add_factura_emitida')[0] as HTMLFormElement).reset();
    resetFacturaPreview();
    $('#fact_modal_id_medidor').val(factCurrentMeter.id);
    const factData = (window as any).factData || {};
    const svcCfg = factData.serviceConfig?.[factCurrentService] || { label: factCurrentService };
    $('#fact-modal-ctx-label').text(`${factCurrentProperty.name} — ${svcCfg.label}`);
    $('#fact-modal-ctx-detail').text(`Medidor: ${factCurrentMeter.name} (SN: ${factCurrentMeter.codigo})`);

    // Autocompletar el precio base por consumo con el precio de la base de datos de propiedad
    let basePrice = '';
    const propId = String(factCurrentProperty.id);
    const propObj = factData.propiedades?.find((p: any) => String(p.id_propiedad) === propId);
    if (propObj) {
        if (factCurrentService === 'energia') basePrice = propObj.precio_kwh_propiedad;
        else if (factCurrentService === 'agua') basePrice = propObj.precio_agua_m3_propiedad;
        else if (factCurrentService === 'gas') basePrice = propObj.precio_gas_m3_propiedad;
    }
    $('#manual_precio_unitario').val(basePrice || '');

    $('#fact-modal-ctx-responsable').text('Responsable: Cargando...');
    const formDataResp = new FormData();
    formDataResp.append('id_medidor', String(factCurrentMeter.id));
    formDataResp.append('tipo_servicio', factCurrentService);
    fetch('/admin/facturacion/responsable-medidor', {
        method: 'POST',
        body: formDataResp
    }).then(r => r.json()).then(res => {
        if (res.responsable) {
            $('#fact-modal-ctx-responsable').text(`Responsable: ${res.responsable}`);
        } else {
            $('#fact-modal-ctx-responsable').text('Responsable: Sin Asignar');
        }
    }).catch(() => {
        $('#fact-modal-ctx-responsable').text('Responsable: Error al cargar');
    });

    // Cargar correlativo (número de factura) sugerido para este medidor
    const formDataCorr = new FormData();
    formDataCorr.append('id_medidor', String(factCurrentMeter.id));
    fetch('/admin/facturacion/correlativo-medidor', {
        method: 'POST',
        body: formDataCorr
    }).then(r => r.json()).then(res => {
        if (res.status === 200 && res.numero_factura) {
            $('input[name="numero_factura"]').val(res.numero_factura);
            $('#fact_modal_correlativo_factura').val(res.correlativo);
        }
    }).catch(console.error);

    loadLecturasHistoricas();
});

function loadLecturasHistoricas() {
    const idMedidor = factCurrentMeter.id;
    if (!idMedidor) return;

    const formData = new FormData();
    formData.append('id_medidor', String(idMedidor));

    fetch('/admin/facturacion/lecturas-historicas', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            const selAnt = $('#manual_lectura_anterior');
            const selAct = $('#manual_lectura_actual');
            selAnt.empty().append('<option value="">Seleccione lectura base...</option>');
            selAct.empty().append('<option value="">Seleccione lectura actual...</option>');

            if (data.status === 200 && Array.isArray(data.results)) {
                data.results.forEach((r: any) => {
                    const parts = String(r.fecha_lectura).split(' ')[0];
                    const val = Number(r.lectura_actual || 0).toFixed(2);
                    const optionHtml = `<option value="${val}" data-fecha="${parts}">[${parts}] - ${val}</option>`;
                    selAnt.append(optionHtml);
                    selAct.append(optionHtml);
                });
            }
        })
        .catch(error => {
            console.error('Error fetching historico', error);
        });
}

$(document).on('change', '#manual_lectura_actual', function () {
    const selectedOption = $(this).find('option:selected');
    const fecha = selectedOption.data('fecha');
    if (fecha) {
        $('#manual_fecha_lectura').val(fecha);
    }
});

$(document).on('change', '#factura_emitida_year_select, #factura_emitida_month_select', function () {
    loadConsumosPeriodoFacturacion();
});

$(document).on('change', '.factura-consumo-option', function () {
    $('#factura_emitida_consumo_id').val(String($(this).val() || ''));
    // Prellenar base on selection can be complex if we don't have the object, we just load preview.
    // However, when clicking 'Recalcular', it will take whatever is in the manual inputs.
    loadFacturaPreview();
});

$(document).on('click', '#btn_calcular_preview_manual', function () {
    loadFacturaPreview();
});

$(document).on('change', '#manual_precio_unitario', function () {
    loadFacturaPreview();
});

$(document).on('submit', '#form_add_factura_emitida', function (e) {
    e.preventDefault();

    const manualAnt = String($('#manual_lectura_anterior').val() || '');
    const manualAct = String($('#manual_lectura_actual').val() || '');
    const hasManual = manualAnt && manualAct;
    const idConsumo = $('#factura_emitida_consumo_id').val();

    if (!idConsumo && !hasManual) {
        fncSweetAlert('warning', 'Primero debe cargar una lectura válida para el periodo seleccionado o ingresar lecturas manuales.', '');
        return;
    }

    matPreloader("on");
    const formData = new FormData(this as HTMLFormElement);
    formData.append('tipo_servicio', factCurrentService);

    // Obtener la fecha de la lectura anterior seleccionada
    const selectAnterior = document.getElementById('manual_lectura_anterior') as HTMLSelectElement;
    if (selectAnterior && selectAnterior.options.length > 0 && selectAnterior.selectedIndex >= 0) {
        const fechaAnt = selectAnterior.options[selectAnterior.selectedIndex].getAttribute('data-fecha');
        if (fechaAnt) {
            formData.append('manual_fecha_lectura_anterior', fechaAnt);
        }
    }

    fetch('/admin/facturacion/emitir', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            matPreloader("off");
            if (data.status === 200) {
                fncSweetAlertToast('success', data.message || 'Factura emitida correctamente');
                ($('#modal_add_factura_emitida') as any).modal('hide');
                (this as HTMLFormElement).reset();
                if (tableFacturasEmitidas) {
                    tableFacturasEmitidas.ajax.reload(null, false);
                }
                resetFacturaPreview();
            } else {
                fncSweetAlert('error', data.message || 'No se pudo emitir la factura', '');
            }
        })
        .catch(error => {
            console.error('Error al emitir factura:', error);
            matPreloader("off");
            fncSweetAlert('error', 'Ocurrió un error al emitir la factura', '');
        });
});

$(document).on('click', '.btn-edit-factura-emitida', function () {
    const id = $(this).attr('data-id') || '';
    const formData = new FormData();
    formData.append('i', id);
    formData.append('table', 'facturas_emitidas');
    formData.append('suffix', 'factura');

    matPreloader("on");
    fetch('/admin/tables/get', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            matPreloader("off");
            if (data.status === 200 && data.data) {
                $('#edit_id_factura').val(data.data.id_factura || '');
                $('#edit_numero_factura').val(data.data.numero_factura || '');
                $('#edit_fecha_emision').val(data.data.fecha_emision || '');
                $('#edit_fecha_vencimiento').val(data.data.fecha_vencimiento || '');
                $('#edit_estado_pago').val(data.data.estado_pago || 'pendiente');
                $('#edit_pdf_path').val(data.data.pdf_path || '');
                ($('#modal_edit_factura_emitida') as any).modal('show');
            } else {
                fncSweetAlertToast('error', 'No se pudo cargar la factura');
            }
        })
        .catch(error => {
            console.error('Error al cargar factura emitida:', error);
            matPreloader("off");
            fncSweetAlertToast('error', 'No se pudo cargar la factura');
        });
});

$(document).on('submit', '#form_edit_factura_emitida', function (e) {
    e.preventDefault();
    matPreloader("on");
    const formData = new FormData(this as HTMLFormElement);

    fetch('/admin/facturacion/edit', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            matPreloader("off");
            if (data.status === 200) {
                fncSweetAlertToast('success', data.message || 'Factura actualizada');
                ($('#modal_edit_factura_emitida') as any).modal('hide');
                if (tableFacturasEmitidas) {
                    tableFacturasEmitidas.ajax.reload(null, false);
                }
            } else {
                fncSweetAlert('error', data.message || 'No se pudo actualizar la factura', '');
            }
        })
        .catch(error => {
            console.error('Error al actualizar factura:', error);
            matPreloader("off");
            fncSweetAlert('error', 'Ocurrió un error al actualizar la factura', '');
        });
});

$(document).on('click', '.btn-delete-factura-emitida', function () {
    const id = $(this).attr('data-id') || '';

    fncSweetAlert("confirm", "¿Eliminar esta factura emitida?", "").then(resp => {
        if (!resp) {
            return;
        }

        const formData = new FormData();
        formData.append('i', id);
        formData.append('table', 'facturas_emitidas');
        formData.append('suffix', 'factura');

        matPreloader("on");
        fetch('/admin/tables/delete', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                matPreloader("off");
                if (data.status === 200) {
                    fncSweetAlertToast('success', 'Factura eliminada');
                    if (tableFacturasEmitidas) {
                        tableFacturasEmitidas.ajax.reload(null, false);
                    }
                } else {
                    fncSweetAlert('error', 'No se pudo eliminar la factura', '');
                }
            })
            .catch(error => {
                console.error('Error al eliminar factura emitida:', error);
                matPreloader("off");
                fncSweetAlert('error', 'Ocurrió un error al eliminar la factura', '');
            });
    });
});

$(document).on('click', '.btn-send-factura-emitida-email', function () {
    const id = String($(this).data('id') || '');
    const cliente = String($(this).data('cliente') || 'Cliente');
    const factura = String($(this).data('factura') || 'Factura');

    (window as any).Swal.fire({
        title: `Enviar ${factura}`,
        text: `Ingrese el correo destino para ${cliente}`,
        input: 'email',
        inputPlaceholder: 'correo@ejemplo.com',
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light'
        },
        buttonsStyling: false,
        inputValidator: (value: string) => {
            if (!value) {
                return 'Debe ingresar un correo';
            }
            return null;
        }
    }).then((result: any) => {
        if (!result.isConfirmed || !result.value) {
            return;
        }

        const formData = new FormData();
        formData.append('id_factura', id);
        formData.append('email', String(result.value));

        matPreloader("on");
        fetch('/admin/facturacion/enviar-email', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                matPreloader("off");
                if (data.status === 'success') {
                    fncSweetAlertToast('success', data.message || 'Factura enviada correctamente');
                } else {
                    fncSweetAlert('error', data.message || 'No se pudo enviar la factura', '');
                }
            })
            .catch(error => {
                console.error('Error enviando factura por email:', error);
                matPreloader("off");
                fncSweetAlert('error', 'Ocurrió un error al enviar la factura', '');
            });
    });
});

/*=============================================
CONFIGURACIÓN ENERGÍA CRUD (tabla: tarifas)
=============================================*/
var tableConfigEnergia: any = null;
if ($('#tableConfigEnergia').length) {
    tableConfigEnergia = initializeDataTable("#tableConfigEnergia", "/admin/tables/config-energia");
}

function reloadConfigTable() {
    if (tableConfigEnergia) {
        tableConfigEnergia.ajax.reload(null, false);
    }
}

// ── Abrir modal Editar ──────────────────────────
$(document).on('click', '.btn-edit-config', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    const btn = $(this);
    const id = btn.data('id') || '';
    const nombre = btn.data('nombre') || '';
    const valor = btn.data('valor') || '0';
    const unidad = btn.data('unidad') || 'S/.';
    const desc = btn.data('descripcion') || '';

    // IDs actualizados: _tarifa
    $('#edit_id_tarifa').val(id);
    $('#edit_valor_tarifa').val(valor);
    $('#edit_nombre_tarifa_label').text(nombre);
    $('#edit_desc_tarifa_label').text(desc);
    $('#edit_unidad_label').text(unidad);

    const modal = document.getElementById('modal_edit_tarifa');
    if (modal) {
        const bsModal = (window as any).bootstrap?.Modal?.getInstance(modal) || new (window as any).bootstrap.Modal(modal);
        bsModal.show();
    }
});

// ── Guardar Edición ─────────────────────────────
$('#btnGuardarConfig').on('click', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    const form = document.getElementById('formEditConfig') as HTMLFormElement;
    if (!form.checkValidity()) { form.reportValidity(); return; }

    const formData = new FormData(form);
    fetch('/admin/lecturas/config/edit', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(data => {
            if (data.status === 200) {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message || 'Tarifa actualizada');
                const modal = document.getElementById('modal_edit_tarifa');
                if (modal) (window as any).bootstrap?.Modal?.getInstance(modal)?.hide();
                reloadConfigTable();
            } else {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message || 'Error al guardar');
            }
        })
        .catch(error => console.error('Error:', error));
});

// ── Eliminar ────────────────────────────────────
$(document).on('click', '.btn-delete-config', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    const id = $(this).data('id') || '';
    const nombre = $(this).data('nombre') || 'esta tarifa';
    console.log("aca se elimina 1 ")

    if (typeof fncSweetAlert === 'function') {
        fncSweetAlert("confirm", `¿Eliminar la tarifa "${nombre}"?`, null).then((resp: any) => {
            if (resp) {
                const formData = new FormData();
                formData.append('table', 'tarifas');
                formData.append('i', id);
                formData.append('suffix', 'tarifa');

                console.log("aca se elimina 2")

                fetch('/admin/tables/delete', { method: 'POST', body: formData })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 200) {
                            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Tarifa eliminada');
                            reloadConfigTable();
                        } else {
                            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', 'Error al eliminar');
                        }
                    })
                    .catch(error => console.error('Error:', error));
            }
        });
    }
});

// ── Guardar Nueva Tarifa ─────────────────────────
$('#btnGuardarAddConfig').on('click', function (e: JQuery.ClickEvent) {
    e.preventDefault();
    const form = document.getElementById('formAddConfig') as HTMLFormElement;
    if (!form.checkValidity()) { form.reportValidity(); return; }

    const formData = new FormData(form);
    fetch('/admin/lecturas/config/create', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(data => {
            if (data.status === 200) {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message || 'Tarifa registrada');
                const modal = document.getElementById('modal_add_tarifa');
                if (modal) (window as any).bootstrap?.Modal?.getInstance(modal)?.hide();
                form.reset();
                reloadConfigTable();
            } else {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message || 'Error al registrar');
            }
        })
        .catch(error => console.error('Error:', error));
});

/*=============================================
GESTIÓN DE CONSUMOS: FLUJO DRILL-DOWN (NUEVO)
=============================================*/

type ConsumptionLevel = 'properties' | 'meters' | 'management';
var currentPropertySelection = { id: '', name: '', suministro: '' };
var activeSufijo = window.location.pathname.includes('/energia') ? 'kWh' : (window.location.pathname.includes('/agua') ? 'm³' : (window.location.pathname.includes('/gas') ? 'm³' : 'kWh'));

function updateUrlParams(propValue: string | null, meterValue: string | null) {
    const url = new URL(window.location.href);
    if (propValue) {
        url.searchParams.set('propiedad', propValue);
    } else {
        url.searchParams.delete('propiedad');
    }
    if (meterValue) {
        url.searchParams.set('medidor', meterValue);
    } else {
        url.searchParams.delete('medidor');
    }
    window.history.replaceState({}, '', url.toString());
}

function updateStepProgress(step: ConsumptionLevel) {
    $('.step-chip').removeClass('active');
    $(`.step-chip[data-step-chip="${step}"]`).addClass('active');
}

function showConsumptionLevel(step: ConsumptionLevel) {
    const levels: Record<ConsumptionLevel, string> = {
        properties: '#level-properties',
        meters: '#level-meters',
        management: '#level-management'
    };

    Object.entries(levels).forEach(([key, selector]) => {
        const level = $(selector);
        if (key === step) {
            level.removeClass('d-none is-leaving').addClass('is-entering');
            setTimeout(() => level.removeClass('is-entering'), 320);
        } else if (!level.hasClass('d-none')) {
            level.addClass('is-leaving');
            setTimeout(() => level.addClass('d-none').removeClass('is-leaving'), 220);
        }
    });

    updateStepProgress(step);
}

function updateConsumptionPreview(currentSelector: string, previousSelector: string, outputSelector: string) {
    const previousValue = parseFloat(String($(previousSelector).val() || '0')) || 0;
    const currentValue = parseFloat(String($(currentSelector).val() || '0')) || 0;

    let labelSelector = '';
    if (outputSelector === '#history_consumo_preview') {
        labelSelector = '#history_consumo_preview_label';
    } else if (outputSelector === '#edit_consumo_preview') {
        labelSelector = '#edit_consumo_preview_label';
    }

    if (currentValue > previousValue) {
        const total = currentValue - previousValue;
        $(outputSelector).text(`${total.toFixed(2)} ${activeSufijo}`);
        if (labelSelector) {
            if (labelSelector === '#history_consumo_preview_label') {
                $(labelSelector).text('Consumo calculado');
            } else {
                $(labelSelector).text('Consumo recalculado');
            }
        }
    } else {
        $(outputSelector).text(`${currentValue.toFixed(2)} ${activeSufijo}`);
        if (labelSelector) {
            if (labelSelector === '#history_consumo_preview_label') {
                $(labelSelector).text('Nueva lectura');
            } else {
                $(labelSelector).text('Nueva lectura editada');
            }
        }
    }
}

// Nivel 1 -> Nivel 2: Seleccionar Propiedad
$(document).on('click', '.btn-select-property', function () {
    const idProp = $(this).attr('data-id') || '';
    const nombreProp = $(this).attr('data-nombre') || 'Propiedad';
    const suministroProp = $(this).attr('data-suministro') || idProp;

    // Determinar tipo de servicio y sufijo de lectura desde los atributos de datos
    const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
    activeSufijo = $(this).attr(`data-sufijo-${serviceType}`) || (serviceType === 'energia' ? 'kWh' : 'm³');

    currentPropertySelection = { id: idProp, name: nombreProp, suministro: suministroProp };

    // Update URL
    updateUrlParams(suministroProp, null);

    $('#selected-property-title').text(`Medidores de ${serviceType === 'energia' ? 'Energía' : (serviceType === 'agua' ? 'Agua' : 'Gas')} en: ${nombreProp}`);
    renderMetersList(idProp);
    showConsumptionLevel('meters');
});

// Nivel 2 -> Nivel 1: Volver a Propiedades
$(document).on('click', '.btn-back-to-properties', function () {
    updateUrlParams(null, null);
    showConsumptionLevel('properties');
});

// Nivel 2 -> Nivel 3: Seleccionar Medidor
$(document).on('click', '.btn-select-meter', function () {
    const idMed = $(this).attr('data-id') || '';
    const nombreMed = $(this).attr('data-nombre') || 'Medidor';
    const tipoMed = $(this).attr('data-tipo') || 'No definido';
    const codigoMed = $(this).attr('data-codigo') || idMed;

    // Update URL
    updateUrlParams(currentPropertySelection.suministro || currentPropertySelection.id, codigoMed);

    $('#selected-meter-title').text(`Lecturas: ${nombreMed}`);
    $('#selected-meter-subtitle').text(`Tipo: ${tipoMed}`);
    $('#selected-meter-path').text(`${currentPropertySelection.name} / ${nombreMed}`);
    $('#history_id_medidor').val(idMed);
    $('#history_id_propiedad').val(currentPropertySelection.id);

    if (tipoMed === 'Virtual') {
        $('#card_nueva_lectura').hide();
    } else {
        $('#card_nueva_lectura').show();
        $('#wrapper_lectura_manual').show();
        $('#wrapper_fecha_lectura').show();
        $('#history_lectura_actual').attr('required', 'required');
        $('#wrapper_preview_normal').show();
        $('#btn_save_lectura').removeAttr('disabled').html('<i class="fas fa-save me-2"></i> Guardar Lectura');
    }


    loadMeterHistory(idMed);
    showConsumptionLevel('management');
});

// Nivel 3 -> Nivel 2: Volver a Medidores
$(document).on('click', '.btn-back-to-meters', function () {
    updateUrlParams(currentPropertySelection.suministro || currentPropertySelection.id, null);
    showConsumptionLevel('meters');
});

// Pre-calcular consumo virtual eliminado porque el cálculo ahora es automático en la tabla de historial.


function renderMetersList(idProp: string) {
    // @ts-ignore
    const medidores = medidoresPorPropiedad[idProp] || [];
    let html = '';

    $('#selected-property-meta').text(`${medidores.length} medidor${medidores.length === 1 ? '' : 'es'}`);
    $('#meterSearchInput').val('');

    if (medidores.length > 0) {
        medidores.forEach((med: any) => {
            const tipo = med.tipo_medidor || 'Sub-medidor';
            // Custom styles according to service mode
            const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
            const color = (serviceType === 'energia' ? 'warning' : (serviceType === 'agua' ? 'info' : 'danger'));
            const icon = (serviceType === 'energia' ? 'bolt' : (serviceType === 'agua' ? 'tint' : 'fire'));
            const dataSearch = `${med.nombre_medidor || ''} ${med.codigo_medidor || ''} ${tipo}`.toLowerCase();

            html += `
                <div class="col-md-4 col-xl-3 meter-card-item" data-search="${dataSearch}">
                    <div class="card h-100 shadow-sm shadow-hover-lg transition-3d cursor-pointer btn-select-meter" 
                          data-id="${med.id_medidor}" data-nombre="${med.nombre_medidor}" data-tipo="${tipo}" data-codigo="${med.codigo_medidor || ''}">
                        <div class="card-body d-flex flex-column p-7">
                            <div class="d-flex align-items-center mb-5">
                                <div class="symbol symbol-40px me-4">
                                    <span class="symbol-label bg-light-${color}">
                                        <i class="fas fa-${icon} text-${color} fs-3"></i>
                                    </span>
                                </div>
                                <div class="d-flex flex-column">
                                    <span class="text-dark fw-bold fs-6">${med.nombre_medidor}</span>
                                    <span class="text-muted fw-semibold fs-7">${tipo}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-stack mt-auto">
                                <span class="badge badge-light-dark fs-8 px-3 py-2">SN: ${med.codigo_medidor || 'S/N'}</span>
                                <i class="fas fa-chevron-right text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>`;
        });
    } else {
        html = '<div class="col-12"><div class="alert alert-light-primary text-center">No hay medidores en esta propiedad.</div></div>';
    }
    $('#meters-container').html(html);
}

// Cálculo de consumo en tiempo real (Registro)
$(document).on('input', '#history_lectura_actual', function () {
    updateConsumptionPreview('#history_lectura_actual', '#history_lectura_anterior', '#history_consumo_preview');
});

// Cálculo de consumo en tiempo real (Edición)
$(document).on('input', '#edit_lectura_anterior_consumo, #edit_lectura_actual_consumo', function () {
    updateConsumptionPreview('#edit_lectura_actual_consumo', '#edit_lectura_anterior_consumo', '#edit_consumo_preview');
});

var tableHistory: any = null;

function fetchAndRenderHistory(id: string, year: string = 'all') {
    if (tableHistory && ($.fn.DataTable as any).isDataTable('#table_history_medidor')) {
        tableHistory.ajax.reload();
        return;
    }
    tableHistory = null;

    tableHistory = initializeDataTable('#table_history_medidor', '/admin/tables/lecturas', {
        ajax: {
            type: 'POST',
            data: function (d: any) {
                d.id_medidor_filter = $('#history_id_medidor').val();
                d.year_filter = $('#history_year_filter').val() || 'all';
                d.tipo_filtro_medidor = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
            }
        },
        columnDefs: [
            { targets: 0, type: 'num' }, // Forzamos orden numérico por el data-order (timestamp)
            { targets: [2, 3, 4, 5], className: 'text-end' }
        ],
        order: [[0, 'desc']]
    });
}

function loadMeterHistory(id: string | undefined) {
    if (!id) return;

    const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
    const formDataLast = new FormData();
    formDataLast.append('id_medidor', id);
    formDataLast.append('tipo_servicio_consumo', serviceType);
    fetch('/admin/lecturas/last', { method: 'POST', body: formDataLast })
        .then(res => res.json())
        .then(data => {
            $('#history_id_medidor').val(id);
            $('#history_lectura_anterior').val(data.lectura_anterior || '0.00');

            if (data.fecha_anterior) {
                // Reemplazamos el espacio por T para datetime-local
                const fechaAnt = data.fecha_anterior.replace(' ', 'T');
                $('#history_fecha_anterior').val(fechaAnt);

                // Formateamos la fecha anterior para mostrarla de forma bonita (DD/MM/YYYY HH:MM:SS)
                const dateParts = data.fecha_anterior.split(' ');
                const dateYMD = dateParts[0].split('-');
                const formattedDate = dateYMD[2] + '/' + dateYMD[1] + '/' + dateYMD[0] + (dateParts[1] ? ' ' + dateParts[1] : '');

                $('#history_last_reading_val').text(parseFloat(data.lectura_anterior).toFixed(2) + ' ' + activeSufijo);
                $('#history_last_reading_date').text(formattedDate);
                $('#history_last_reading_info').show();
            } else {
                $('#history_fecha_anterior').val('');
                $('#history_lectura_anterior').val('0.00');

                $('#history_last_reading_val').text('0.00 ' + activeSufijo);
                $('#history_last_reading_date').text('Primera lectura (Línea Base)');
                $('#history_last_reading_info').show();
            }

            const now = new Date();
            const localDateTime = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + 'T' +
                String(now.getHours()).padStart(2, '0') + ':' +
                String(now.getMinutes()).padStart(2, '0') + ':' +
                String(now.getSeconds()).padStart(2, '0');
            $('#history_fecha_lectura_actual').val(localDateTime);
            $('#history_lectura_actual').val('');
            updateConsumptionPreview('#history_lectura_actual', '#history_lectura_anterior', '#history_consumo_preview');
        });

    const currentYear = new Date().getFullYear().toString();
    $('#history_year_filter').html(`<option value="${currentYear}">${currentYear}</option>`);

    fetchAndRenderHistory(id, currentYear);

    const fd = new FormData();
    fd.append('id_medidor_filter', id);
    fd.append('tipo_filtro_medidor', serviceType);
    fetch('/admin/tables/lecturas', { method: 'POST', body: fd })
        .then(res => res.json())
        .then(data => {
            const yearsSet = new Set<string>();
            yearsSet.add(currentYear);
            (data.data || []).forEach((row: any) => {
                const dateMatch = row[0].match(/(\d{2})\/(\d{2})\/(\d{4})/);
                if (dateMatch) yearsSet.add(dateMatch[3]);
            });

            const sortedYears = Array.from(yearsSet).sort((a, b) => b.localeCompare(a));
            let yearOptions = '';
            sortedYears.forEach(y => { yearOptions += `<option value="${y}" ${y === currentYear ? 'selected' : ''}>${y}</option>`; });
            $('#history_year_filter').html(yearOptions);
        });
}

$(document).on('change', '#history_year_filter', function () {
    const id = $('#history_id_medidor').val() as string;
    fetchAndRenderHistory(id, $(this).val() as string);
});

$(document).on('submit', '#formAddConsumoHistory', function (e) {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
    formData.append('tipo_servicio_consumo', serviceType);

    fetch('/admin/lecturas/create', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if (data.status === 200) {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message || 'Lectura registrada');

                // Save current meter ID before reset to preserve context
                const currentMeterId = $('#history_id_medidor').val();

                form.reset();

                // Reload history which updates previous reading, baseline, dates, and clears inputs
                if (currentMeterId) {
                    loadMeterHistory(currentMeterId.toString());
                }
            } else {
                if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message || 'Error al guardar');
            }
        })
        .catch(error => console.error('Error:', error));
});

// Buscador de medidores en Panel de Registro de Consumo
$(document).on('input', '#meterSearchInput', function (this: HTMLInputElement) {
    const query = $(this).val().toString().toLowerCase().trim();

    $('.meter-card-item').each(function () {
        const dataSearch = $(this).attr('data-search') || '';
        if (dataSearch.indexOf(query) !== -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});

// Buscador de PROPIEDADES en Panel de Registro de Consumo
$(document).on('input', '#propertySearchInput', function (this: HTMLInputElement) {
    const query = $(this).val().toString().toLowerCase().trim();
    $('.property-card-item').each(function () {
        const dataSearch = $(this).attr('data-search') || '';
        if (dataSearch.indexOf(query) !== -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});


/*=============================================
GESTIÓN DE EMPRESAS
=============================================*/
if ($('#tableEmpresas').length > 0) {
    const tableEmpresas = ($('#tableEmpresas') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/empresas',
            type: 'POST'
        },
        language: {
            url: '//cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json'
        }
    });

    $(document).on('click', '.btn-edit-empresa', function (this: HTMLElement) {
        const id = $(this).attr('data-id');
        const nombre = $(this).attr('data-nombre');
        const ruc = $(this).attr('data-ruc');
        const direccion = $(this).attr('data-direccion');
        const email = $(this).attr('data-email');
        const telefono = $(this).attr('data-telefono');
        const logo = $(this).attr('data-logo');
        const colorP = $(this).attr('data-color-p');
        const colorS = $(this).attr('data-color-s');
        const fb = $(this).attr('data-fb');
        const ig = $(this).attr('data-ig');
        const web = $(this).attr('data-web');
        const slug = $(this).attr('data-slug');
        const dominio = $(this).attr('data-dominio');
        const cwActivo = $(this).attr('data-cw-activo');
        const cwDomain = $(this).attr('data-cw-domain');
        const cwToken = $(this).attr('data-cw-token');
        const cwPos = $(this).attr('data-cw-pos');
        const cwType = $(this).attr('data-cw-type');
        const cwTitle = $(this).attr('data-cw-title');
        
        const estado = $(this).attr('data-estado');
        const whatsapp = $(this).attr('data-whatsapp');
        const msjFactura = $(this).attr('data-msj-factura');
        const prefijoFactura = $(this).attr('data-prefijo-factura');

        $('#edit_id_empresa').val(id || '');
        $('#edit_nombre_empresa').val(nombre || '');
        $('#edit_ruc_empresa').val(ruc || '');
        $('#edit_direccion_empresa').val(direccion || '');
        $('#edit_email_empresa').val(email || '');
        $('#edit_telefono_empresa').val(telefono || '');
        $('#edit_logo_empresa').val(logo || '');
        $('#edit_color_primario_empresa').val(colorP || '#0095E8');
        $('#edit_color_secundario_empresa').val(colorS || '#1E1E2D');
        $('#edit_web_empresa').val(web || '');
        $('#edit_facebook_empresa').val(fb || '');
        $('#edit_instagram_empresa').val(ig || '');
        
        $('#edit_estado_empresa').val(estado || '1');
        $('#edit_whatsapp_soporte_empresa').val(whatsapp || '');
        $('#edit_mensaje_factura_empresa').val(msjFactura || '');
        $('#edit_prefijo_factura_empresa').val(prefijoFactura || '');
        
        $('#edit_slug_empresa').val(slug || '');
        $('#edit_dominio_empresa').val(dominio || '');
        $('#edit_chatwoot_activo').prop('checked', cwActivo === '1');
        $('#edit_chatwoot_domain').val(cwDomain || '');
        $('#edit_chatwoot_website_token').val(cwToken || '');
        $('#edit_chatwoot_position').val(cwPos || 'right');
        $('#edit_chatwoot_type').val(cwType || 'expanded_bubble');
        $('#edit_chatwoot_launcher_title').val(cwTitle || '');

        ($('#modal_edit_empresa') as any).modal('show');
    });

    $(document).on('click', '.btn-delete-empresa', function (this: HTMLElement) {
        const id = $(this).attr('data-id');
        if (confirm('¿Estás seguro de eliminar esta empresa?')) {
            const formData = new FormData();
            formData.append('id', String(id));
            formData.append('table', 'empresas');
            formData.append('column', 'id_empresa');

            fetch('/superadmin/tables/delete', {
                method: 'POST',
                body: formData
            })
                .then(res => res.json())
                .then(data => {
                    if (data.status === 200) {
                        tableEmpresas.ajax.reload();
                        if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Empresa eliminada');
                    }
                });
        }
    });
}

var formAddEmpresa = document.getElementById('form_add_empresa');
if (formAddEmpresa) {
    formAddEmpresa.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/empresas/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_add_empresa') as any).modal('hide');
                    (formAddEmpresa as HTMLFormElement).reset();
                    ($('#tableEmpresas') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

var formEditEmpresa = document.getElementById('form_edit_empresa');
if (formEditEmpresa) {
    formEditEmpresa.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/empresas/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_edit_empresa') as any).modal('hide');
                    ($('#tableEmpresas') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

/*=============================================
GESTIÓN DE USUARIOS (SUPERADMIN)
=============================================*/
if ($('#tableUsuarios').length > 0) {
    const tableUsuarios = ($('#tableUsuarios') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/usuarios',
            type: 'POST'
        },
        language: {
            url: '//cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json'
        }
    });

    $(document).on('click', '.btn-edit-usuario', function (this: HTMLElement) {
        const id = $(this).attr('data-id');
        const fname = $(this).attr('data-fname');
        const lname = $(this).attr('data-lname');
        const email = $(this).attr('data-email');
        const phone = $(this).attr('data-phone');
        const dni = $(this).attr('data-dni');
        const rol = $(this).attr('data-rol');
        const status = $(this).attr('data-status');
        const empresa = $(this).attr('data-empresa');

        $('#edit_id_user').val(id || '');
        $('#edit_first_name_user').val(fname || '');
        $('#edit_last_name_user').val(lname || '');
        $('#edit_email_user').val(email || '');
        $('#edit_phone_user').val(phone || '');
        $('#edit_dni_user').val(dni || '');
        
        if (rol) {
            $('#edit_rol_user').val(rol).trigger('change');
        }
        if (status) {
            $('#edit_status_user').val(status).trigger('change');
        }
        if (empresa !== undefined) {
            $('#edit_id_empresa').val(empresa).trigger('change');
        }

        ($('#modal_edit_usuario') as any).modal('show');
    });

    $(document).on('click', '.btn-delete-usuario', function (this: HTMLElement) {
        const id = $(this).attr('data-id');
        if (confirm('¿Estás seguro de eliminar este usuario?')) {
            const formData = new FormData();
            formData.append('id', String(id));
            formData.append('table', 'users');
            formData.append('column', 'id_user');

            fetch('/superadmin/tables/delete', {
                method: 'POST',
                body: formData
            })
                .then(res => res.json())
                .then(data => {
                    if (data.status === 200) {
                        tableUsuarios.ajax.reload();
                        if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Usuario eliminado');
                    }
                });
        }
    });
}

var formAddUsuario = document.getElementById('form_add_usuario');
if (formAddUsuario) {
    formAddUsuario.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/usuarios/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_add_usuario') as any).modal('hide');
                    (formAddUsuario as HTMLFormElement).reset();
                    ($('#tableUsuarios') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

var formEditUsuario = document.getElementById('form_edit_usuario');
if (formEditUsuario) {
    formEditUsuario.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/usuarios/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_edit_usuario') as any).modal('hide');
                    ($('#tableUsuarios') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

// Controlador de clic para abrir el selector de fecha al hacer clic en el icono del calendario
$(document).on('click', '.input-group-text, .input-group-text i', function (e) {
    e.stopPropagation();
    const $group = $(this).closest('.input-group');
    const $input = $group.find('input[type="datetime-local"]');
    if ($input.length > 0) {
        const inputEl = $input[0] as HTMLInputElement;
        const isReadOnly = $input.prop('readonly') || $input.prop('readOnly') || inputEl.readOnly;
        if (!isReadOnly && !inputEl.disabled) {
            try {
                if (typeof inputEl.showPicker === 'function') {
                    inputEl.showPicker();
                } else {
                    inputEl.focus();
                    inputEl.click();
                }
            } catch (err) {
                inputEl.focus();
                inputEl.click();
            }
        }
    }
});

// Controlador de clic para abrir el selector de fecha al hacer clic en el propio input
$(document).on('click', 'input[type="datetime-local"]', function (e) {
    const inputEl = this as HTMLInputElement;
    const isReadOnly = $(this).prop('readonly') || $(this).prop('readOnly') || inputEl.readOnly;
    if (!isReadOnly && !inputEl.disabled) {
        try {
            if (typeof inputEl.showPicker === 'function') {
                inputEl.showPicker();
            }
        } catch (err) {
            // fallback
        }
    }
});

(window as any).restoreLecturasStepState = function () {
    if (!$('#level-properties').length) {
        return;
    }

    const serviceType = window.location.pathname.includes('/energia') ? 'energia' : (window.location.pathname.includes('/agua') ? 'agua' : (window.location.pathname.includes('/gas') ? 'gas' : 'energia'));
    activeSufijo = serviceType === 'energia' ? 'kWh' : 'm³';

    const params = new URLSearchParams(window.location.search);
    const propiedadUrl = params.get('propiedad');
    const medidorUrl = params.get('medidor');

    if (propiedadUrl) {
        // Buscar tarjeta de propiedad por suministro o por ID
        let propCard = $(`.btn-select-property[data-suministro="${propiedadUrl}"]`);
        if (!propCard.length) {
            propCard = $(`.btn-select-property[data-id="${propiedadUrl}"]`);
        }

        if (propCard.length) {
            const idProp = propCard.attr('data-id') || '';
            const nombreProp = propCard.attr('data-nombre') || 'Propiedad';
            const suministroProp = propCard.attr('data-suministro') || idProp;

            activeSufijo = propCard.attr(`data-sufijo-${serviceType}`) || (serviceType === 'energia' ? 'kWh' : 'm³');
            currentPropertySelection = { id: idProp, name: nombreProp, suministro: suministroProp };

            $('#selected-property-title').text(`Medidores de ${serviceType === 'energia' ? 'Energía' : (serviceType === 'agua' ? 'Agua' : 'Gas')} en: ${nombreProp}`);
            renderMetersList(idProp);

            if (medidorUrl) {
                // Como renderMetersList renderiza síncronamente, podemos buscar el medidor inmediatamente
                let meterCard = $(`.btn-select-meter[data-codigo="${medidorUrl}"]`);
                if (!meterCard.length) {
                    meterCard = $(`.btn-select-meter[data-id="${medidorUrl}"]`);
                }

                if (meterCard.length) {
                    const idMed = meterCard.attr('data-id') || '';
                    const nombreMed = meterCard.attr('data-nombre') || 'Medidor';
                    const tipoMed = meterCard.attr('data-tipo') || 'No definido';

                    $('#selected-meter-title').text(`Lecturas: ${nombreMed}`);
                    $('#selected-meter-subtitle').text(`Tipo: ${tipoMed}`);
                    $('#selected-meter-path').text(`${nombreProp} / ${nombreMed}`);
                    $('#history_id_medidor').val(idMed);
                    $('#history_id_propiedad').val(idProp);

                    if (tipoMed === 'Virtual') {
                        $('#card_nueva_lectura').hide();
                    } else {
                        $('#card_nueva_lectura').show();
                        $('#wrapper_lectura_manual').show();
                        $('#wrapper_fecha_lectura').show();
                        $('#history_lectura_actual').attr('required', 'required');
                        $('#wrapper_preview_normal').show();
                        $('#btn_save_lectura').removeAttr('disabled').html('<i class="fas fa-save me-2"></i> Guardar Lectura');
                    }

                    loadMeterHistory(idMed);
                    showConsumptionLevel('management');
                } else {
                    showConsumptionLevel('meters');
                }
            } else {
                showConsumptionLevel('meters');
            }
        } else {
            showConsumptionLevel('properties');
        }
    } else {
        showConsumptionLevel('properties');
    }
};

// ===================== FACTURACIÓN: RESTAURAR ESTADO DESDE URL =====================
(window as any).restoreFacturacionStepState = function () {
    if (!$('#fact-level-properties').length) return;

    const params = new URLSearchParams(window.location.search);
    const propUrl = params.get('propiedad');
    const svcUrl = params.get('servicio');
    const medUrl = params.get('medidor');

    if (!propUrl) return; // Sin params → quedarse en nivel 1

    // Buscar propiedad por suministro o ID
    let propCard = $(`.btn-fact-select-prop[data-suministro="${propUrl}"]`);
    if (!propCard.length) propCard = $(`.btn-fact-select-prop[data-id="${propUrl}"]`);
    if (!propCard.length) return;

    const idProp = propCard.attr('data-id') || '';
    const nombreProp = propCard.attr('data-nombre') || 'Propiedad';
    const suministroProp = propCard.attr('data-suministro') || idProp;
    factCurrentProperty = { id: idProp, name: nombreProp, suministro: suministroProp };

    if (!svcUrl) {
        // Solo propiedad → nivel 2 servicios
        $('#fact-svc-title').text(`Servicios en: ${nombreProp}`);
        renderFactServiceCards(idProp);
        showFactLevel('services');
        return;
    }

    factCurrentService = svcUrl;
    const factData = (window as any).factData || {};
    const svcCfg = factData.serviceConfig?.[svcUrl] || { label: svcUrl };

    if (!medUrl) {
        // Propiedad + servicio → nivel 3 medidores
        $('#fact-meter-title').text(`Medidores de ${svcCfg.label}: ${nombreProp}`);
        renderFactMetersList(idProp, svcUrl);
        showFactLevel('meters');
        return;
    }

    // Propiedad + servicio + medidor → nivel 4 facturas
    // Renderizar medidores primero para buscar la tarjeta
    renderFactMetersList(idProp, svcUrl);
    let meterCard = $(`.btn-fact-select-meter[data-codigo="${medUrl}"]`);
    if (!meterCard.length) meterCard = $(`.btn-fact-select-meter[data-id="${medUrl}"]`);

    if (meterCard.length) {
        const idMed = meterCard.attr('data-id') || '';
        const nombreMed = meterCard.attr('data-nombre') || 'Medidor';
        const codigoMed = meterCard.attr('data-codigo') || idMed;
        factCurrentMeter = { id: idMed, name: nombreMed, codigo: codigoMed };
        $('#fact-inv-title').text(`Facturas: ${nombreMed}`);
        $('#fact-inv-subtitle').text(`${svcCfg.label} · SN: ${codigoMed}`);
        $('#fact-inv-path').text(`${nombreProp} / ${svcCfg.label} / ${nombreMed}`);
        initFacturasTable(idMed);
        showFactLevel('invoices');
    } else {
        // Medidor no encontrado, quedarse en nivel 3
        $('#fact-meter-title').text(`Medidores de ${svcCfg.label}: ${nombreProp}`);
        showFactLevel('meters');
    }
};

$(document).ready(function () {
    if (typeof (window as any).initializeActiveTables === 'function') {
        (window as any).initializeActiveTables();
    }
});

$(document).on('click', '.btn-mark-paid-factura', function () {
    const id = $(this).attr('data-id') || '';
    if (!id) return;
    
    fncSweetAlert('confirm', '¿Marcar esta factura como PAGADA?', null).then((resp: any) => {
        if (resp) {
            matPreloader("on");
            const formData = new FormData();
            formData.append('id_factura', id);
            formData.append('estado_pago', 'pagada');
            
            fetch('/admin/facturacion/status', {
                method: 'POST',
                body: formData
            })
            .then(res => res.json())
            .then(data => {
                matPreloader("off");
                if (data.status === 200) {
                    fncSweetAlertToast('success', data.message || 'Factura marcada como pagada');
                    if (tableFacturasEmitidas) {
                        tableFacturasEmitidas.ajax.reload(null, false);
                    }
                } else {
                    fncSweetAlertToast('error', data.message || 'Error al actualizar el estado');
                }
            })
            .catch(error => {
                matPreloader("off");
                console.error('Error:', error);
                fncSweetAlertToast('error', 'Error al procesar la solicitud');
            });
        }
    });
});

$(document).on('click', '.btn-mark-cancelled-factura', function () {
    const id = $(this).attr('data-id') || '';
    if (!id) return;
    
    fncSweetAlert('confirm', '¿Marcar esta factura como ANULADA?', null).then((resp: any) => {
        if (resp) {
            matPreloader("on");
            const formData = new FormData();
            formData.append('id_factura', id);
            formData.append('estado_pago', 'anulada');
            
            fetch('/admin/facturacion/status', {
                method: 'POST',
                body: formData
            })
            .then(res => res.json())
            .then(data => {
                matPreloader("off");
                if (data.status === 200) {
                    fncSweetAlertToast('success', data.message || 'Factura marcada como anulada');
                    if (tableFacturasEmitidas) {
                        tableFacturasEmitidas.ajax.reload(null, false);
                    }
                } else {
                    fncSweetAlertToast('error', data.message || 'Error al actualizar el estado');
                }
            })
            .catch(error => {
                matPreloader("off");
                console.error('Error:', error);
                fncSweetAlertToast('error', 'Error al procesar la solicitud');
            });
        }
    });
});

// ==========================================
// CRUD PLANES
// ==========================================
if ($('#tablePlanes').length > 0) {
    const tablePlanes = ($('#tablePlanes') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/planes',
            type: 'POST',
        },
        language: { url: '//cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json' },
        responsive: true
    });

    $(document).on('click', '.btn-edit-plan', function () {
        const id = $(this).attr('data-id');
        const nombre = $(this).attr('data-nombre');
        const desc = $(this).attr('data-desc');
        const precio = $(this).attr('data-precio');
        const prop = $(this).attr('data-prop');
        const med = $(this).attr('data-med');
        const freq = $(this).attr('data-freq');
        const status = $(this).attr('data-status');

        $('#edit_id_plan').val(id);
        $('#edit_name_plan').val(nombre);
        $('#edit_description_plan').val(desc);
        $('#edit_price_plan').val(precio);
        $('#edit_limite_propiedades_plan').val(prop);
        $('#edit_limite_medidores_plan').val(med);

        if ($('#edit_duration_plan').data('select2')) {
            $('#edit_duration_plan').val(freq).trigger('change');
        } else {
            $('#edit_duration_plan').val(freq);
        }

        if (status == 1) {
            $('#edit_status_plan').prop('checked', true);
        } else {
            $('#edit_status_plan').prop('checked', false);
        }

        ($('#modal_saas_edit_plan') as any).modal('show');
    });

    $(document).on('click', '.btn-delete-plan', function () {
        const id = $(this).attr('data-id');
        if (!id) return;

        fncSweetAlert('confirm', '¿Estás seguro de eliminar este plan?', null).then((resp: any) => {
            if (resp) {
                const formData = new FormData();
                formData.append('table', 'planes');
                formData.append('i', id);
                formData.append('suffix', 'plan');

                fetch('/superadmin/tables/delete', {
                    method: 'POST',
                    body: formData
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 200) {
                            tablePlanes.ajax.reload();
                            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Plan eliminado');
                        }
                    });
            }
        });
    });
}

var formAddPlanSaas = document.getElementById('form_saas_add_plan');
if (formAddPlanSaas) {
    formAddPlanSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/planes/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_saas_add_plan') as any).modal('hide');
                    (formAddPlanSaas as HTMLFormElement).reset();
                    ($('#tablePlanes') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

var formEditPlanSaas = document.getElementById('form_saas_edit_plan');
if (formEditPlanSaas) {
    formEditPlanSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/planes/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_saas_edit_plan') as any).modal('hide');
                    ($('#tablePlanes') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

// ----------------------------------------------------
// SuperAdmin Propiedades
// ----------------------------------------------------
if ($('#tablePropiedadesSuperAdmin').length > 0) {
    const tablePropiedadesSuperAdmin = ($('#tablePropiedadesSuperAdmin') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/propiedades',
            type: 'POST',
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json"
        },
        responsive: true
    });

    // Delete
    $('#tablePropiedadesSuperAdmin').on('click', '.btn-delete-propiedad', function () {
        const id = $(this).data('id');
        if (typeof fncSweetAlert === 'function') {
            fncSweetAlert("confirm", "¿Eliminar esta propiedad?", "/superadmin/propiedades/delete?id=" + id).then((res: any) => {
                if (res) tablePropiedadesSuperAdmin.ajax.reload();
            });
        }
    });

    // Edit
    $('#tablePropiedadesSuperAdmin').on('click', '.btn-saas-edit-propiedad', function () {
        const $btn = $(this);
        
        $('#edit_id_propiedad').val($btn.data('id'));
        $('#edit_id_empresa_propiedad').val($btn.data('empresa')).trigger('change');
        $('#edit_nombre_propiedad').val($btn.data('nombre'));
        $('#edit_tipo_propiedad').val($btn.data('tipo'));
        $('#edit_suministro_propiedad').val($btn.data('suministro'));
        $('#edit_direccion_propiedad').val($btn.data('direccion'));
        $('#edit_precio_kwh').val($btn.data('precio-kwh'));
        $('#edit_precio_agua').val($btn.data('precio-agua'));
        $('#edit_precio_gas').val($btn.data('precio-gas'));
        $('#edit_moneda').val($btn.data('moneda'));
        $('#edit_prefijo_moneda').val($btn.data('prefijo-moneda'));
        $('#edit_sufijo_energia').val($btn.data('sufijo-energia'));
        $('#edit_sufijo_agua').val($btn.data('sufijo-agua'));
        $('#edit_sufijo_gas').val($btn.data('sufijo-gas'));
        $('#edit_prefijo_impuesto').val($btn.data('prefijo-impuesto'));
        $('#edit_valor_impuesto').val($btn.data('valor-impuesto'));
        
        ($('#modal_saas_edit_propiedad') as any).modal('show');
    });
}

var formAddPropiedadSaas = document.getElementById('form_saas_add_propiedad');
if (formAddPropiedadSaas) {
    formAddPropiedadSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/propiedades/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    (this as HTMLFormElement).reset();
                    ($('#modal_saas_add_propiedad') as any).modal('hide');
                    ($('#tablePropiedadesSuperAdmin') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

var formEditPropiedadSaas = document.getElementById('form_saas_edit_propiedad');
if (formEditPropiedadSaas) {
    formEditPropiedadSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/propiedades/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_saas_edit_propiedad') as any).modal('hide');
                    ($('#tablePropiedadesSuperAdmin') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

// ----------------------------------------------------
// SuperAdmin Facturas
// ----------------------------------------------------
if ($('#tableFacturasSuperAdmin').length > 0) {
    const tableFacturasSuperAdmin = ($('#tableFacturasSuperAdmin') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/facturas',
            type: 'POST',
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json"
        },
        responsive: true,
        order: [[0, "desc"]]
    });

    // Delete
    $('#tableFacturasSuperAdmin').on('click', '.btn-delete-factura', function () {
        const id = $(this).data('id');
        if (typeof fncSweetAlert === 'function') {
            fncSweetAlert("confirm", "¿Eliminar esta factura?", "/superadmin/facturas/delete?id=" + id).then((res: any) => {
                if (res) tableFacturasSuperAdmin.ajax.reload();
            });
        }
    });

    // Edit
    $('#tableFacturasSuperAdmin').on('click', '.btn-saas-edit-factura', function () {
        const $btn = $(this);
        
        $('#edit_id_factura').val($btn.data('id'));
        $('#edit_correlativo_factura').val($btn.data('correlativo'));
        $('#edit_tipo_servicio').val($btn.data('servicio')).trigger('change');
        $('#edit_monto_total').val($btn.data('monto'));
        $('#edit_estado_pago').val($btn.data('estado')).trigger('change');
        $('#edit_periodo_anio').val($btn.data('anio'));
        $('#edit_periodo_mes').val($btn.data('mes'));
        $('#edit_fecha_emision').val($btn.data('emision'));
        $('#edit_fecha_vencimiento').val($btn.data('vencimiento'));
        
        ($('#modal_saas_edit_factura') as any).modal('show');
    });
}

var formAddFacturaSaas = document.getElementById('form_saas_add_factura');
if (formAddFacturaSaas) {
    formAddFacturaSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/facturas/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    (this as HTMLFormElement).reset();
                    ($('#modal_saas_add_factura') as any).modal('hide');
                    ($('#tableFacturasSuperAdmin') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

var formEditFacturaSaas = document.getElementById('form_saas_edit_factura');
if (formEditFacturaSaas) {
    formEditFacturaSaas.addEventListener('submit', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        fetch('/superadmin/facturas/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    ($('#modal_saas_edit_factura') as any).modal('hide');
                    ($('#tableFacturasSuperAdmin') as any).DataTable().ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });
}

// ----------------------------------------------------
// SuperAdmin Notificaciones Log
// ----------------------------------------------------
if ($('#tableNotificacionesSuperAdmin').length > 0) {
    const tableNotificacionesSuperAdmin = ($('#tableNotificacionesSuperAdmin') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/notificaciones',
            type: 'POST',
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json"
        },
        responsive: true,
        order: [[0, "desc"]]
    });

    // Delete
    $('#tableNotificacionesSuperAdmin').on('click', '.btn-delete-notificacion', function () {
        const id = $(this).data('id');
        if (typeof fncSweetAlert === 'function') {
            fncSweetAlert("confirm", "¿Eliminar este registro del log?", "/superadmin/notificaciones/delete?id=" + id).then((res: any) => {
                if (res) tableNotificacionesSuperAdmin.ajax.reload();
            });
        }
    });
}

// ----------------------------------------------------
// SuperAdmin Tareas
// ----------------------------------------------------
if ($('#tableTareasSuperAdmin').length > 0) {
    const tableTareasSuperAdmin = ($('#tableTareasSuperAdmin') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/tareas',
            type: 'POST',
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json"
        },
        responsive: true,
        order: [[0, "desc"]]
    });

    // Create
    $('#form_saas_crear_tarea').on('submit', function (e) {
        e.preventDefault();
        const btn = document.getElementById('btn_saas_crear_tarea');
        btn?.setAttribute('data-kt-indicator', 'on');
        btn?.setAttribute('disabled', 'disabled');

        const formData = new FormData(this as HTMLFormElement);
        fetch('/superadmin/tareas/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                btn?.removeAttribute('data-kt-indicator');
                btn?.removeAttribute('disabled');
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    $('#modal_saas_crear_tarea').modal('hide');
                    (this as HTMLFormElement).reset();
                    tableTareasSuperAdmin.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Edit modal population
    $('#tableTareasSuperAdmin').on('click', '.btn-saas-edit-tarea', function () {
        $('#edit_id_tarea').val($(this).data('id'));
        $('#edit_titulo_tarea').val($(this).data('titulo'));
        $('#edit_descripcion_tarea').val($(this).data('descripcion'));
        $('#edit_frecuencia_tarea').val($(this).data('frecuencia')).trigger('change');
        $('#edit_estado_tarea').val($(this).data('estado')).trigger('change');
        $('#modal_saas_editar_tarea').modal('show');
    });

    // Edit submit
    $('#form_saas_editar_tarea').on('submit', function (e) {
        e.preventDefault();
        const btn = document.getElementById('btn_saas_editar_tarea');
        btn?.setAttribute('data-kt-indicator', 'on');
        btn?.setAttribute('disabled', 'disabled');

        const formData = new FormData(this as HTMLFormElement);
        fetch('/superadmin/tareas/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                btn?.removeAttribute('data-kt-indicator');
                btn?.removeAttribute('disabled');
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    $('#modal_saas_editar_tarea').modal('hide');
                    tableTareasSuperAdmin.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Delete
    $('#tableTareasSuperAdmin').on('click', '.btn-delete-tarea', function () {
        const id = $(this).data('id');
        if (typeof fncSweetAlert === 'function') {
            fncSweetAlert("confirm", "¿Eliminar esta tarea?", "/superadmin/tareas/delete?id=" + id).then((res: any) => {
                if (res) tableTareasSuperAdmin.ajax.reload();
            });
        }
    });
}

// ----------------------------------------------------
// SuperAdmin Roles
// ----------------------------------------------------
if ($('#tableRolesSuperAdmin').length > 0) {
    const tableRolesSuperAdmin = ($('#tableRolesSuperAdmin') as any).DataTable({
        ajax: {
            url: '/superadmin/tables/roles',
            type: 'POST',
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Spanish.json"
        },
        responsive: true,
        order: [[0, "desc"]]
    });

    // Create
    $('#form_saas_crear_rol').on('submit', function (e) {
        e.preventDefault();
        const btn = document.getElementById('btn_saas_crear_rol');
        btn?.setAttribute('data-kt-indicator', 'on');
        btn?.setAttribute('disabled', 'disabled');

        const formData = new FormData(this as HTMLFormElement);
        fetch('/superadmin/roles/create', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                btn?.removeAttribute('data-kt-indicator');
                btn?.removeAttribute('disabled');
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    $('#modal_saas_crear_rol').modal('hide');
                    (this as HTMLFormElement).reset();
                    tableRolesSuperAdmin.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Edit modal population
    $('#tableRolesSuperAdmin').on('click', '.btn-saas-edit-rol', function () {
        $('#edit_id_rol').val($(this).data('id'));
        $('#edit_nombre_rol').val($(this).data('nombre'));
        $('#edit_descripcion_rol').val($(this).data('descripcion'));
        $('#modal_saas_editar_rol').modal('show');
    });

    // Edit submit
    $('#form_saas_editar_rol').on('submit', function (e) {
        e.preventDefault();
        const btn = document.getElementById('btn_saas_editar_rol');
        btn?.setAttribute('data-kt-indicator', 'on');
        btn?.setAttribute('disabled', 'disabled');

        const formData = new FormData(this as HTMLFormElement);
        fetch('/superadmin/roles/edit', { method: 'POST', body: formData })
            .then(res => res.json())
            .then(data => {
                btn?.removeAttribute('data-kt-indicator');
                btn?.removeAttribute('disabled');
                if (data.status === 'success') {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', data.message);
                    $('#modal_saas_editar_rol').modal('hide');
                    tableRolesSuperAdmin.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Delete
    $('#tableRolesSuperAdmin').on('click', '.btn-delete-rol', function () {
        const id = $(this).data('id');
        if (typeof fncSweetAlert === 'function') {
            fncSweetAlert("confirm", "¿Eliminar este rol?", "/superadmin/roles/delete?id=" + id).then((res: any) => {
                if (res) tableRolesSuperAdmin.ajax.reload();
            });
        }
    });
}
